import { createReducer } from 'redux-act';
import actions from '../actions/payrollActions';

const initialState = {
  getEmployeeDetailsByPayDaysPending: false,
  getEmployeeDetailsByPayDaysRes: null,
  getEmployeeDetailsByPayDaysError: null,

  getAttendanceStatusPending: false,
  getAttendanceStatusRes: null,
  getAttendanceStatusError: null,

  updateAttendanceTrackingPending: false,
  updateAttendanceTrackingRes: null,
  updateAttendanceTrackingError: null,

  addEarningsPending: false,
  addEarningsRes: null,
  addEarningsError: null,

  updateEarningsPending: false,
  updateEarningsRes: null,
  updateEarningsError: null,

  getEarningsPending: false,
  getEarningsRes: null,
  getEarningsError: null,

  addDeductionsPending: false,
  addDeductionsRes: null,
  addDeductionsError: null,

  updateDeductionsPending: false,
  updateDeductionsRes: null,
  updateDeductionsError: null,

  getDeductionsPending: false,
  getDeductionsRes: null,
  getDeductionsError: null,

  addTaxSlabsPending: false,
  addTaxSlabsRes: null,
  addTaxSlabsError: null,

  addEarningTypesPending: false,
  addEarningTypesRes: null,
  addEarningTypesError: null,

  updateEarningTypesPending: false,
  updateEarningTypesRes: null,
  updateEarningTypesError: null,

  getEarningTypePending: false,
  getEarningTypeRes: null,
  getEarningTypeError: null,

  getAllEarningTypePending: false,
  getAllEarningTypeRes: null,
  getAllEarningTypeError: null,

  getEarningTypeByIdPending: false,
  getEarningTypeByIdRes: null,
  getEarningTypeByIdError: null,

  addDeductionTypesPending: false,
  addDeductionTypesRes: null,
  addDeductionTypesError: null,

  updateDeductionTypesPending: false,
  updateDeductionTypesRes: null,
  updateDeductionTypesError: null,

  getDeductionTypePending: false,
  getDeductionTypeRes: null,
  getDeductionTypeError: null,

  getAllDeductionTypePending: false,
  getAllDeductionTypeRes: null,
  getAllDeductionTypeError: null,

  getDeductionTypeByIdPending: false,
  getDeductionTypeByIdRes: null,
  getDeductionTypeByIdError: null,

  generateSalaryTemplatePending: false,
  generateSalaryTemplateRes: null,
  generateSalaryTemplateError: null,

  saveSalaryTemplatePending: false,
  saveSalaryTemplateRes: null,
  saveSalaryTemplateError: null,

  getAllSalaryTemplatePending: false,
  getAllSalaryTemplateRes: null,
  getAllSalaryTemplateError: null,

  getSalaryTemplatePending: false,
  getSalaryTemplateRes: null,
  getSalaryTemplateError: null,

  updateSalaryTemplatePending: false,
  updateSalaryTemplateRes: null,
  updateSalaryTemplateError: null,

  getSalaryTemplateByIdPending: false,
  getSalaryTemplateByIdRes: null,
  getSalaryTemplateByIdError: null,

  getAllEarningPending: false,
  getAllEarningRes: null,
  getAllEarningError: null,

  getAllDeductionPending: false,
  getAllDeductionRes: null,
  getAllDeductionError: null,

  calculateCtcPending: false,
  calculateCtcRes: null,
  calculateCtcError: null,

  addArrearsPending: false,
  addArrearsRes: null,
  addArrearsError: null,

  getArrearsPending: false,
  getArrearsRes: null,
  getArrearsError: null,

  addEmployeeSalaryPending: false,
  addEmployeeSalaryRes: null,
  addEmployeeSalaryError: null,

  getEmployeeSalaryPending: false,
  getEmployeeSalaryRes: null,
  getEmployeeSalaryError: null,

  updateEmployeeSalaryPending: false,
  updateEmployeeSalaryRes: null,
  updateEmployeeSalaryError: null,

  getAllEmployeeAssignStatusPending: false,
  getAllEmployeeAssignStatusRes: null,
  getAllEmployeeAssignStatusError: null,

  addPayRunPending: false,
  addPayRunRes: null,
  addPayRunError: null,

  addPaySchedulePending: false,
  addPayScheduleRes: null,
  addPayScheduleError: null,

  updatePaySchedulePending: false,
  updatePayScheduleRes: null,
  updatePayScheduleError: null,

  upcomingPayrollsPending: false,
  upcomingPayrollsRes: null,
  upcomingPayrollsError: null,

  payRollNotificationPending: false,
  payRollNotificationRes: null,
  payRollNotificationError: null,

  getPayRunPending: false,
  getPayRunRes: null,
  getPayRunError: null,

  getPayRunDashboardDataPending: false,
  getPayRunDashboardDataRes: null,
  getPayRunDashboardDataError: null,

  getPayRunHistoryPending: false,
  getPayRunHistoryRes: null,
  getPayRunHistoryError: null,

  approvePayrollPending: false,
  approvePayrollRes: null,
  approvePayrollError: null,

  addTaxSlabPending: false,
  addTaxSlabRes: null,
  addTaxSlabError: null,

  updateTaxSlabPending: false,
  updateTaxSlabRes: null,
  updateTaxSlabError: null,

  getTaxSlabPending: false,
  getTaxSlabRes: null,
  getTaxSlabError: null,

  getAllTaxSlabPending: false,
  getAllTaxSlabRes: null,
  getAllTaxSlabError: null,

  deleteTaxSlabPending: false,
  deleteTaxSlabRes: null,
  deleteTaxSlabError: null,

  addEmployeeInvestmentPending: false,
  addEmployeeInvestmentRes: null,
  addEmployeeInvestmentError: null,

  getEmployeeInvestmentPending: false,
  getEmployeeInvestmentRes: null,
  getEmployeeInvestmentError: null,

  updateEmployeeInvestmentPending: false,
  updateEmployeeInvestmentRes: null,
  updateEmployeeInvestmentError: null,

  deleteEmployeeInvestmentPending: false,
  deleteEmployeeInvestmentRes: null,
  deleteEmployeeInvestmentError: null,

  addInvestmentCategoryPending: false,
  addInvestmentCategoryRes: null,
  addInvestmentCategoryError: null,

  updateInvestmentCategoryPending: false,
  updateInvestmentCategoryRes: null,
  updateInvestmentCategoryError: null,

  getInvestmentCategoryPending: false,
  getInvestmentCategoryRes: null,
  getInvestmentCategoryError: null,

  getAllInvestmentCategoryPending: false,
  getAllInvestmentCategoryRes: null,
  getAllInvestmentCategoryError: null,

  deleteInvestmentCategoryPending: false,
  deleteInvestmentCategoryRes: null,
  deleteInvestmentCategoryError: null,

  addInvestmentSubCategoryPending: false,
  addInvestmentSubCategoryRes: null,
  addInvestmentSubCategoryError: null,

  updateInvestmentSubCategoryPending: false,
  updateInvestmentSubCategoryRes: null,
  updateInvestmentSubCategoryError: null,

  getInvestmentSubCategoryPending: false,
  getInvestmentSubCategoryRes: null,
  getInvestmentSubCategoryError: null,

  getAllInvestmentSubCategoryPending: false,
  getAllInvestmentSubCategoryRes: null,
  getAllInvestmentSubCategoryError: null,

  deleteInvestmentSubCategoryPending: false,
  deleteInvestmentSubCategoryRes: null,
  deleteInvestmentSubCategoryError: null,

  getAllInvestmentCategoryDetailsPending: false,
  getAllInvestmentCategoryDetailsRes: null,
  getAllInvestmentCategoryDetailsError: null,

  addLoansPending: false,
  addLoansRes: null,
  addLoansError: null,

  updateLoansPending: false,
  updateLoansRes: null,
  updateLoansError: null,

  getLoansPending: false,
  getLoansRes: null,
  getLoansError: null,

  applyAdvancePending: false,
  applyAdvanceRes: null,
  applyAdvanceError: null,

  getAdvanceApprovalPending: false,
  getAdvanceApprovalRes: null,
  getAdvanceApprovalError: null,

  getAdvanceRequestPending: false,
  getAdvanceRequestRes: null,
  getAdvanceRequestError: null,

  approvalRejectAdvancePending: false,
  approvalRejectAdvanceRes: null,
  approvalRejectAdvanceError: null,

  checkRuleFormulaPending: false,
  checkRuleFormulaRes: null,
  checkRuleFormulaError: null,

  employeeInvestmentProofPending: false,
  employeeInvestmentProofRes: null,
  employeeInvestmentProofError: null,

  getEmployeeInvestmentProofPending: false,
  getEmployeeInvestmentProofRes: null,
  getEmployeeInvestmentProofError: null,

  updateEmployeeInvestmentProofPending: false,
  updateEmployeeInvestmentProofRes: null,
  updateEmployeeInvestmentProofError: null,

  deleteEmployeeInvestmentProofPending: false,
  deleteEmployeeInvestmentProofRes: null,
  deleteEmployeeInvestmentProofError: null,

  commentInEmployeeInvestmentProofPending: false,
  commentInEmployeeInvestmentProofRes: null,
  commentInEmployeeInvestmentProofError: null,

  getAllEmployeeSalaryPending: false,
  getAllEmployeeSalaryRes: null,
  getAllEmployeeSalaryError: null,

  getEmployeeMonthlySalaryPending: false,
  getEmployeeMonthlySalaryRes: null,
  getEmployeeMonthlySalaryError: null,

  generateSalarySlipPending: false,
  generateSalarySlipRes: null,
  generateSalarySlipError: null,

  sendOfferLetterPending: false,
  sendOfferLetterRes: null,
  sendOfferLetterError: null,

  getCandidateSalaryPending: false,
  getCandidateSalaryRes: null,
  getCandidateSalaryError: null,

  updateEmployeeMonthlySalaryPending: false,
  updateEmployeeMonthlySalaryRes: null,
  updateEmployeeMonthlySalaryError: null,

  deleteEarningPending: false,
  deleteEarningRes: null,
  deleteEarningError: null,

  deleteDeductionPending: false,
  deleteDeductionRes: null,
  deleteDeductionError: null,

  deleteEarningTypePending: false,
  deleteEarningTypeRes: null,
  deleteEarningTypeError: null,

  deleteDeductionTypePending: false,
  deleteDeductionTypeRes: null,
  deleteDeductionTypeError: null,

  deleteSalaryTemplatePending: false,
  deleteSalaryTemplateRes: null,
  deleteSalaryTemplateError: null,

  getEmployeeMonthlyPaySlipPending: false,
  getEmployeeMonthlyPaySlipRes: null,
  getEmployeeMonthlyPaySlipError: null,

  selectedEmployeeData: null,
  actionType: null

};
/* Get Employee Details By PayDays Reducers */
const handleGetEmployeeDetailsByPayDaysRequest = state => {
  return {
    ...state,
    ...{
      getEmployeeDetailsByPayDaysPending: true,
      getEmployeeDetailsByPayDaysRes: null,
      getEmployeeDetailsByPayDaysError: null,
    },
  };
};
const handleGetEmployeeDetailsByPayDaysSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getEmployeeDetailsByPayDaysPending: false,
      getEmployeeDetailsByPayDaysRes: payload,
      getEmployeeDetailsByPayDaysError: null,
    },
  };
};
const handleGetEmployeeDetailsByPayDaysError = (state, payload) => ({
  ...state,
  ...{
    getEmployeeDetailsByPayDaysPending: false,
    getEmployeeDetailsByPayDaysRes: null,
    getEmployeeDetailsByPayDaysError: payload,
  },
});


/* Get Attendance Status Reducers */
const handleGetAttendanceStatusRequest = state1 => {
  return {
    ...state1,
    ...{
      getAttendanceStatusPending: true,
      getAttendanceStatusRes: null,
      getAttendanceStatusError: null,
    },
  };
};
const handleGetAttendanceStatusSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAttendanceStatusPending: false,
      getAttendanceStatusRes: payload,
      getAttendanceStatusError: null,
    },
  };
};
const handleGetAttendanceStatusError = (state1, payload) => ({
  ...state1,
  ...{
    getAttendanceStatusPending: false,
    getAttendanceStatusRes: null,
    getAttendanceStatusError: payload,
  },
});

/* Update Attendance Tracking Reducers */
const handleUpdateAttendanceTrackingRequest = state1 => {
  return {
    ...state1,
    ...{
      updateAttendanceTrackingPending: true,
      updateAttendanceTrackingRes: null,
      updateAttendanceTrackingError: null,
    },
  };
};
const handleUpdateAttendanceTrackingSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateAttendanceTrackingPending: false,
      updateAttendanceTrackingRes: payload,
      updateAttendanceTrackingError: null,
    },
  };
};
const handleUpdateAttendanceTrackingError = (state1, payload) => ({
  ...state1,
  ...{
    updateAttendanceTrackingPending: false,
    updateAttendanceTrackingRes: null,
    updateAttendanceTrackingError: payload,
  },
});

/* Add Earnings Reducers */
const handleAddEarningsRequest = state1 => {
  return {
    ...state1,
    ...{
      addEarningsPending: true,
      addEarningsRes: null,
      addEarningsError: null,
    },
  };
};
const handleAddEarningsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      addEarningsPending: false,
      addEarningsRes: payload,
      addEarningsError: null,
    },
  };
};
const handleAddEarningsError = (state1, payload) => ({
  ...state1,
  ...{
    addEarningsPending: false,
    addEarningsRes: null,
    addEarningsError: payload,
  },
});

/* Update Earnings Reducers */
const handleUpdateEarningsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateEarningsPending: true,
      updateEarningsRes: null,
      updateEarningsError: null,
    },
  };
};
const handleUpdateEarningsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateEarningsPending: false,
      updateEarningsRes: payload,
      updateEarningsError: null,
    },
  };
};
const handleUpdateEarningsError = (state1, payload) => ({
  ...state1,
  ...{
    updateEarningsPending: false,
    updateEarningsRes: null,
    updateEarningsError: payload,
  },
});



/* Get Earnings Reducers */
const handleGetEarningsRequest = state1 => {
  return {
    ...state1,
    ...{
      getEarningsPending: true,
      getEarningsRes: null,
      getEarningsError: null,
    },
  };
};
const handleGetEarningsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEarningsPending: false,
      getEarningsRes: payload,
      getEarningsError: null,
    },
  };
};
const handleGetEarningsError = (state1, payload) => ({
  ...state1,
  ...{
    getEarningsPending: false,
    getEarningsRes: null,
    getEarningsError: payload,
  },
});


/* Add Deductions Reducers */
const handleAddDeductionsRequest = state1 => {
  return {
    ...state1,
    ...{
      addDeductionsPending: true,
      addDeductionsRes: null,
      addDeductionsError: null,
    },
  };
};
const handleAddDeductionsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      addDeductionsPending: false,
      addDeductionsRes: payload,
      addDeductionsError: null,
    },
  };
};
const handleAddDeductionsError = (state1, payload) => ({
  ...state1,
  ...{
    addDeductionsPending: false,
    addDeductionsRes: null,
    addDeductionsError: payload,
  },
});

/* Update Deductions Reducers */
const handleUpdateDeductionsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateDeductionsPending: true,
      updateDeductionsRes: null,
      updateDeductionsError: null,
    },
  };
};
const handleUpdateDeductionsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateDeductionsPending: false,
      updateDeductionsRes: payload,
      updateDeductionsError: null,
    },
  };
};
const handleUpdateDeductionsError = (state1, payload) => ({
  ...state1,
  ...{
    updateDeductionsPending: false,
    updateDeductionsRes: null,
    updateDeductionsError: payload,
  },
});

/* Get Deductions Reducers */
const handleGetDeductionsRequest = state1 => {
  return {
    ...state1,
    ...{
      getDeductionsPending: true,
      getDeductionsRes: null,
      getDeductionsError: null,
    },
  };
};
const handleGetDeductionsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getDeductionsPending: false,
      getDeductionsRes: payload,
      getDeductionsError: null,
    },
  };
};
const handleGetDeductionsError = (state1, payload) => ({
  ...state1,
  ...{
    getDeductionsPending: false,
    getDeductionsRes: null,
    getDeductionsError: payload,
  },
});

/* Add Tax Slabs Reducers */
const handleAddTaxSlabsRequest = state1 => {
  return {
    ...state1,
    ...{
      addTaxSlabsPending: true,
      addTaxSlabsRes: null,
      addTaxSlabsError: null,
    },
  };
};
const handleAddTaxSlabsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      addTaxSlabsPending: false,
      addTaxSlabsRes: payload,
      addTaxSlabsError: null,
    },
  };
};
const handleAddTaxSlabsError = (state1, payload) => ({
  ...state1,
  ...{
    addTaxSlabsPending: false,
    addTaxSlabsRes: null,
    addTaxSlabsError: payload,
  },
});

/* Add Earning Types Reducers */
const handleAddEarningTypesRequest = state1 => {
  return {
    ...state1,
    ...{
      addEarningTypesPending: true,
      addEarningTypesRes: null,
      addEarningTypesError: null,
    },
  };
};
const handleAddEarningTypesSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      addEarningTypesPending: false,
      addEarningTypesRes: payload,
      addEarningTypesError: null,
    },
  };
};
const handleAddEarningTypesError = (state1, payload) => ({
  ...state1,
  ...{
    addEarningTypesPending: false,
    addEarningTypesRes: null,
    addEarningTypesError: payload,
  },
});

/* Update Earning Types Reducers */
const handleUpdateEarningTypesRequest = state1 => {
  return {
    ...state1,
    ...{
      updateEarningTypesPending: true,
      updateEarningTypesRes: null,
      updateEarningTypesError: null,
    },
  };
};
const handleUpdateEarningTypesSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateEarningTypesPending: false,
      updateEarningTypesRes: payload,
      updateEarningTypesError: null,
    },
  };
};
const handleUpdateEarningTypesError = (state1, payload) => ({
  ...state1,
  ...{
    updateEarningTypesPending: false,
    updateEarningTypesRes: null,
    updateEarningTypesError: payload,
  },
});

/* Get Earning Type Reducers */
const handleGetEarningTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      getEarningTypePending: true,
      getEarningTypeRes: null,
      getEarningTypeError: null,
    },
  };
};
const handleGetEarningTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEarningTypePending: false,
      getEarningTypeRes: payload,
      getEarningTypeError: null,
    },
  };
};
const handleGetEarningTypeError = (state1, payload) => ({
  ...state1,
  ...{
    getEarningTypePending: false,
    getEarningTypeRes: null,
    getEarningTypeError: payload,
  },
});

/* Get All Earning Type Reducers */
const handleGetAllEarningTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllEarningTypePending: true,
      getAllEarningTypeRes: null,
      getAllEarningTypeError: null,
    },
  };
};
const handleGetAllEarningTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllEarningTypePending: false,
      getAllEarningTypeRes: payload,
      getAllEarningTypeError: null,
    },
  };
};
const handleGetAllEarningTypeError = (state1, payload) => ({
  ...state1,
  ...{
    getAllEarningTypePending: false,
    getAllEarningTypeRes: null,
    getAllEarningTypeError: payload,
  },
});

/* Get All Earning Type Reducers */
const handleGetEarningTypeByIdRequest = state1 => {
  return {
    ...state1,
    ...{
      getEarningTypeByIdPending: true,
      getEarningTypeByIdRes: null,
      getEarningTypeByIdError: null,
    },
  };
};
const handleGetEarningTypeByIdSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEarningTypeByIdPending: false,
      getEarningTypeByIdRes: payload,
      getEarningTypeByIdError: null,
    },
  };
};
const handleGetEarningTypeByIdError = (state1, payload) => ({
  ...state1,
  ...{
    getEarningTypeByIdPending: false,
    getEarningTypeByIdRes: null,
    getEarningTypeByIdError: payload,
  },
});


/* Add Deduction Types Reducers */
const handleAddDeductionTypesRequest = state1 => {
  return {
    ...state1,
    ...{
      addDeductionTypesPending: true,
      addDeductionTypesRes: null,
      addDeductionTypesError: null,
    },
  };
};
const handleAddDeductionTypesSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      addDeductionTypesPending: false,
      addDeductionTypesRes: payload,
      addDeductionTypesError: null,
    },
  };
};
const handleAddDeductionTypesError = (state1, payload) => ({
  ...state1,
  ...{
    addDeductionTypesPending: false,
    addDeductionTypesRes: null,
    addDeductionTypesError: payload,
  },
});

/* Update Deduction Types Reducers */
const handleUpdateDeductionTypesRequest = state1 => {
  return {
    ...state1,
    ...{
      updateDeductionTypesPending: true,
      updateDeductionTypesRes: null,
      updateDeductionTypesError: null,
    },
  };
};
const handleUpdateDeductionTypesSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateDeductionTypesPending: false,
      updateDeductionTypesRes: payload,
      updateDeductionTypesError: null,
    },
  };
};
const handleUpdateDeductionTypesError = (state1, payload) => ({
  ...state1,
  ...{
    updateDeductionTypesPending: false,
    updateDeductionTypesRes: null,
    updateDeductionTypesError: payload,
  },
});

/* Get Deduction Type Reducers */
const handleGetDeductionTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      getDeductionTypePending: true,
      getDeductionTypeRes: null,
      getDeductionTypeError: null,
    },
  };
};
const handleGetDeductionTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getDeductionTypePending: false,
      getDeductionTypeRes: payload,
      getDeductionTypeError: null,
    },
  };
};
const handleGetDeductionTypeError = (state1, payload) => ({
  ...state1,
  ...{
    getDeductionTypePending: false,
    getDeductionTypeRes: null,
    getDeductionTypeError: payload,
  },
});

/* Get All Deduction Type Reducers */
const handleGetAllDeductionTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllDeductionTypePending: true,
      getAllDeductionTypeRes: null,
      getAllDeductionTypeError: null,
    },
  };
};
const handleGetAllDeductionTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllDeductionTypePending: false,
      getAllDeductionTypeRes: payload,
      getAllDeductionTypeError: null,
    },
  };
};
const handleGetAllDeductionTypeError = (state1, payload) => ({
  ...state1,
  ...{
    getAllDeductionTypePending: false,
    getAllDeductionTypeRes: null,
    getAllDeductionTypeError: payload,
  },
});

/* Get All Deduction Type Reducers */
const handleGetDeductionTypeByIdRequest = state1 => {
  return {
    ...state1,
    ...{
      getDeductionTypeByIdPending: true,
      getDeductionTypeByIdRes: null,
      getDeductionTypeByIdError: null,
    },
  };
};
const handleGetDeductionTypeByIdSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getDeductionTypeByIdPending: false,
      getDeductionTypeByIdRes: payload,
      getDeductionTypeByIdError: null,
    },
  };
};
const handleGetDeductionTypeByIdError = (state1, payload) => ({
  ...state1,
  ...{
    getDeductionTypeByIdPending: false,
    getDeductionTypeByIdRes: null,
    getDeductionTypeByIdError: payload,
  },
});


/*generate Salary Template reducers*/
const handleGenerateSalaryTemplateRequest = state => {
  return {
    ...state,
    ...{
      generateSalaryTemplatePending: true,
      generateSalaryTemplateRes: null,
      generateSalaryTemplateError: null,
    },
  };
};
const handleGenerateSalaryTemplateSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      generateSalaryTemplatePending: false,
      generateSalaryTemplateRes: payload,
      generateSalaryTemplateError: null,
    },
  };
};
const handleGenerateSalaryTemplateError = (state, payload) => ({
  ...state,
  ...{
    generateSalaryTemplatePending: false,
    generateSalaryTemplateRes: null,
    generateSalaryTemplateError: payload,
  },
});

/*save Salary Template reducers*/
const handleSaveSalaryTemplateRequest = state => {
  return {
    ...state,
    ...{
      saveSalaryTemplatePending: true,
      saveSalaryTemplateRes: null,
      saveSalaryTemplateError: null,
    },
  };
};
const handleSaveSalaryTemplateSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      saveSalaryTemplatePending: false,
      saveSalaryTemplateRes: payload,
      saveSalaryTemplateError: null,
    },
  };
};
const handleSaveSalaryTemplateError = (state, payload) => ({
  ...state,
  ...{
    saveSalaryTemplatePending: false,
    saveSalaryTemplateRes: null,
    saveSalaryTemplateError: payload,
  },
});

/*get All Salary Template reducers*/
const handleGetAllSalaryTemplateRequest = state => {
  return {
    ...state,
    ...{
      getAllSalaryTemplatePending: true,
      getAllSalaryTemplateRes: null,
      getAllSalaryTemplateError: null,
    },
  };
};
const handleGetAllSalaryTemplateSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllSalaryTemplatePending: false,
      getAllSalaryTemplateRes: payload,
      getAllSalaryTemplateError: null,
    },
  };
};
const handleGetAllSalaryTemplateError = (state, payload) => ({
  ...state,
  ...{
    getAllSalaryTemplatePending: false,
    getAllSalaryTemplateRes: null,
    getAllSalaryTemplateError: payload,
  },
});

/* Get  Salary Template reducers*/
const handleGetSalaryTemplateRequest = state => {
  return {
    ...state,
    ...{
      getSalaryTemplatePending: true,
      getSalaryTemplateRes: null,
      getSalaryTemplateError: null,
    },
  };
};
const handleGetSalaryTemplateSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getSalaryTemplatePending: false,
      getSalaryTemplateRes: payload,
      getSalaryTemplateError: null,
    },
  };
};
const handleGetSalaryTemplateError = (state, payload) => ({
  ...state,
  ...{
    getSalaryTemplatePending: false,
    getSalaryTemplateRes: null,
    getSalaryTemplateError: payload,
  },
});

/* Update  Salary Template reducers*/
const handleUpdateSalaryTemplateRequest = state => {
  return {
    ...state,
    ...{
      updateSalaryTemplatePending: true,
      updateSalaryTemplateRes: null,
      updateSalaryTemplateError: null,
    },
  };
};
const handleUpdateSalaryTemplateSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateSalaryTemplatePending: false,
      updateSalaryTemplateRes: payload,
      updateSalaryTemplateError: null,
    },
  };
};
const handleUpdateSalaryTemplateError = (state, payload) => ({
  ...state,
  ...{
    updateSalaryTemplatePending: false,
    updateSalaryTemplateRes: null,
    updateSalaryTemplateError: payload,
  },
});

/*Get Salary Template By Id reducers*/
const handleGetSalaryTemplateByIdRequest = state => {
  return {
    ...state,
    ...{
      getSalaryTemplateByIdPending: true,
      getSalaryTemplateByIdRes: null,
      getSalaryTemplateByIdError: null,
    },
  };
};
const handleGetSalaryTemplateByIdSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getSalaryTemplateByIdPending: false,
      getSalaryTemplateByIdRes: payload,
      getSalaryTemplateByIdError: null,
    },
  };
};
const handleGetSalaryTemplateByIdError = (state, payload) => ({
  ...state,
  ...{
    getSalaryTemplateByIdPending: false,
    getSalaryTemplateByIdRes: null,
    getSalaryTemplateByIdError: payload,
  },
});

/*get All Earning reducers*/
const handleGetAllEarningRequest = state => {
  return {
    ...state,
    ...{
      getAllEarningPending: true,
      getAllEarningRes: null,
      getAllEarningError: null,
    },
  };
};
const handleGetAllEarningSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllEarningPending: false,
      getAllEarningRes: payload,
      getAllEarningError: null,
    },
  };
};
const handleGetAllEarningError = (state, payload) => ({
  ...state,
  ...{
    getAllEarningPending: false,
    getAllEarningRes: null,
    getAllEarningError: payload,
  },
});

/*get  All Deduction reducers*/
const handleGetAllDeductionRequest = state => {
  return {
    ...state,
    ...{
      getAllDeductionPending: true,
      getAllDeductionRes: null,
      getAllDeductionError: null,
    },
  };
};
const handleGetAllDeductionSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllDeductionPending: false,
      getAllDeductionRes: payload,
      getAllDeductionError: null,
    },
  };
};
const handleGetAllDeductionError = (state, payload) => ({
  ...state,
  ...{
    getAllDeductionPending: false,
    getAllDeductionRes: null,
    getAllDeductionError: payload,
  },
});

/*calculate Ctc reducers*/
const handleCalculateCtcRequest = state => {
  return {
    ...state,
    ...{
      calculateCtcPending: true,
      calculateCtcRes: null,
      calculateCtcError: null,
    },
  };
};
const handleCalculateCtcSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      calculateCtcPending: false,
      calculateCtcRes: payload,
      calculateCtcError: null,
    },
  };
};
const handleCalculateCtcError = (state, payload) => ({
  ...state,
  ...{
    calculateCtcPending: false,
    calculateCtcRes: null,
    calculateCtcError: payload,
  },
});

/*Add Arrears reducers*/
const handleAddArrearsRequest = state => {
  return {
    ...state,
    ...{
      addArrearsPending: true,
      addArrearsRes: null,
      addArrearsError: null,
    },
  };
};
const handleAddArrearsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addArrearsPending: false,
      addArrearsRes: payload,
      addArrearsError: null,
    },
  };
};
const handleAddArrearsError = (state, payload) => ({
  ...state,
  ...{
    addArrearsPending: false,
    addArrearsRes: null,
    addArrearsError: payload,
  },
});

/*get Arrears reducers*/
const handleGetArrearsRequest = state => {
  return {
    ...state,
    ...{
      getArrearsPending: true,
      getArrearsRes: null,
      getArrearsError: null,
    },
  };
};
const handleGetArrearsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getArrearsPending: false,
      getArrearsRes: payload,
      getArrearsError: null,
    },
  };
};
const handleGetArrearsError = (state, payload) => ({
  ...state,
  ...{
    getArrearsPending: false,
    getArrearsRes: null,
    getArrearsError: payload,
  },
});

/*add Employee Salary reducers*/
const handleAddEmployeeSalaryRequest = state => {
  return {
    ...state,
    ...{
      addEmployeeSalaryPending: true,
      addEmployeeSalaryRes: null,
      addEmployeeSalaryError: null,
    },
  };
};
const handleAddEmployeeSalarySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addEmployeeSalaryPending: false,
      addEmployeeSalaryRes: payload,
      addEmployeeSalaryError: null,
    },
  };
};
const handleAddEmployeeSalaryError = (state, payload) => ({
  ...state,
  ...{
    addEmployeeSalaryPending: false,
    addEmployeeSalaryRes: null,
    addEmployeeSalaryError: payload,
  },
});

/*Get Employee Salary reducers*/
const handleGetEmployeeSalaryRequest = state => {
  return {
    ...state,
    ...{
      getEmployeeSalaryPending: true,
      getEmployeeSalaryRes: null,
      getEmployeeSalaryError: null,
    },
  };
};
const handleGetEmployeeSalarySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getEmployeeSalaryPending: false,
      getEmployeeSalaryRes: payload,
      getEmployeeSalaryError: null,
    },
  };
};
const handleGetEmployeeSalaryError = (state, payload) => ({
  ...state,
  ...{
    getEmployeeSalaryPending: false,
    getEmployeeSalaryRes: null,
    getEmployeeSalaryError: payload,
  },
});

/*Update Employee Salary reducers*/
const handleUpdateEmployeeSalaryRequest = state => {
  return {
    ...state,
    ...{
      updateEmployeeSalaryPending: true,
      updateEmployeeSalaryRes: null,
      updateEmployeeSalaryError: null,
    },
  };
};
const handleUpdateEmployeeSalarySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateEmployeeSalaryPending: false,
      updateEmployeeSalaryRes: payload,
      updateEmployeeSalaryError: null,
    },
  };
};
const handleUpdateEmployeeSalaryError = (state, payload) => ({
  ...state,
  ...{
    updateEmployeeSalaryPending: false,
    updateEmployeeSalaryRes: null,
    updateEmployeeSalaryError: payload,
  },
});



/*Get All Employee Assign Status reducers*/
const handleGetAllEmployeeAssignStatusRequest = state => {
  return {
    ...state,
    ...{
      getAllEmployeeAssignStatusPending: true,
      getAllEmployeeAssignStatusRes: null,
      getAllEmployeeAssignStatusError: null,
    },
  };
};
const handleGetAllEmployeeAssignStatusSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllEmployeeAssignStatusPending: false,
      getAllEmployeeAssignStatusRes: payload,
      getAllEmployeeAssignStatusError: null,
    },
  };
};
const handleGetAllEmployeeAssignStatusError = (state, payload) => ({
  ...state,
  ...{
    getAllEmployeeAssignStatusPending: false,
    getAllEmployeeAssignStatusRes: null,
    getAllEmployeeAssignStatusError: payload,
  },
});

/* Add Pay Run reducers */
const handleAddPayRunRequest = state => {
  return {
    ...state,
    ...{
      addPayRunPending: true,
      addPayRunRes: null,
      addPayRunError: null,
    },
  };
};
const handleAddPayRunSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addPayRunPending: false,
      addPayRunRes: payload,
      addPayRunError: null,
    },
  };
};
const handleAddPayRunError = (state, payload) => ({
  ...state,
  ...{
    addPayRunPending: false,
    addPayRunRes: null,
    addPayRunError: payload,
  },
});

/* Add Pay Schedule reducers */
const handleAddPayScheduleRequest = state => {
  return {
    ...state,
    ...{
      addPaySchedulePending: true,
      addPayScheduleRes: null,
      addPayScheduleError: null,
    },
  };
};
const handleAddPayScheduleSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addPaySchedulePending: false,
      addPayScheduleRes: payload,
      addPayScheduleError: null,
    },
  };
};
const handleAddPayScheduleError = (state, payload) => ({
  ...state,
  ...{
    addPaySchedulePending: false,
    addPayScheduleRes: null,
    addPayScheduleError: payload,
  },
});

/* Update Pay Schedule reducers */
const handleUpdatePayScheduleRequest = state => {
  return {
    ...state,
    ...{
      updatePaySchedulePending: true,
      updatePayScheduleRes: null,
      updatePayScheduleError: null,
    },
  };
};
const handleUpdatePayScheduleSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updatePaySchedulePending: false,
      updatePayScheduleRes: payload,
      updatePayScheduleError: null,
    },
  };
};
const handleUpdatePayScheduleError = (state, payload) => ({
  ...state,
  ...{
    updatePaySchedulePending: false,
    updatePayScheduleRes: null,
    updatePayScheduleError: payload,
  },
});

/* Upcoming Payrolls reducers */
const handleUpcomingPayrollsRequest = state => {
  return {
    ...state,
    ...{
      upcomingPayrollsPending: true,
      upcomingPayrollsRes: null,
      upcomingPayrollsError: null,
    },
  };
};
const handleUpcomingPayrollsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      upcomingPayrollsPending: false,
      upcomingPayrollsRes: payload,
      upcomingPayrollsError: null,
    },
  };
};
const handleUpcomingPayrollsError = (state, payload) => ({
  ...state,
  ...{
    upcomingPayrollsPending: false,
    upcomingPayrollsRes: null,
    upcomingPayrollsError: payload,
  },
});

/* Upcoming Payrolls reducers */
const handlePayRollNotificationRequest = state => {
  return {
    ...state,
    ...{
      payRollNotificationPending: true,
      payRollNotificationRes: null,
      payRollNotificationError: null,
    },
  };
};
const handlePayRollNotificationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      payRollNotificationPending: false,
      payRollNotificationRes: payload,
      payRollNotificationError: null,
    },
  };
};
const handlePayRollNotificationError = (state, payload) => ({
  ...state,
  ...{
    payRollNotificationPending: false,
    payRollNotificationRes: null,
    payRollNotificationError: payload,
  },
});

/* Get Pay Run Payreducers */
const handleGetPayRunRequest = state => {
  return {
    ...state,
    ...{
      getPayRunPending: true,
      getPayRunRes: null,
      getPayRunError: null,
    },
  };
};
const handleGetPayRunSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getPayRunPending: false,
      getPayRunRes: payload,
      getPayRunError: null,
    },
  };
};
const handleGetPayRunError = (state, payload) => ({
  ...state,
  ...{
    getPayRunPending: false,
    getPayRunRes: null,
    getPayRunError: payload,
  },
});

/* Get Pay Run Dashboard Data */
const handleGetPayRunDashboardDataRequest = state => {
  return {
    ...state,
    ...{
      getPayRunDashboardDataPending: true,
      getPayRunDashboardDataRes: null,
      getPayRunDashboardDataError: null,
    },
  };
};
const handleGetPayRunDashboardDataSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getPayRunDashboardDataPending: false,
      getPayRunDashboardDataRes: payload,
      getPayRunDashboardDataError: null,
    },
  };
};
const handleGetPayRunDashboardDataError = (state, payload) => ({
  ...state,
  ...{
    getPayRunDashboardDataPending: false,
    getPayRunDashboardDataRes: null,
    getPayRunDashboardDataError: payload,
  },
});


/* Get Pay Run History Reducers */
const handleGetPayRunHistoryRequest = state => {
  return {
    ...state,
    ...{
      getPayRunHistoryPending: true,
      getPayRunHistoryRes: null,
      getPayRunHistoryError: null,
    },
  };
};
const handleGetPayRunHistorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getPayRunHistoryPending: false,
      getPayRunHistoryRes: payload,
      getPayRunHistoryError: null,
    },
  };
};
const handleGetPayRunHistoryError = (state, payload) => ({
  ...state,
  ...{
    getPayRunHistoryPending: false,
    getPayRunHistoryRes: null,
    getPayRunHistoryError: payload,
  },
});

/* Get Pay Run History Reducers */
const handleApprovePayrollRequest = state => {
  return {
    ...state,
    ...{
      approvePayrollPending: true,
      approvePayrollRes: null,
      approvePayrollError: null,
    },
  };
};
const handleApprovePayrollSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      approvePayrollPending: false,
      approvePayrollRes: payload,
      approvePayrollError: null,
    },
  };
};
const handleApprovePayrollError = (state, payload) => ({
  ...state,
  ...{
    approvePayrollPending: false,
    approvePayrollRes: null,
    approvePayrollError: payload,
  },
});

/* Add Tax Slab Reducers */
const handleAddTaxSlabRequest = state => {
  return {
    ...state,
    ...{
      addTaxSlabPending: true,
      addTaxSlabRes: null,
      addTaxSlabError: null,
    },
  };
};
const handleAddTaxSlabSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addTaxSlabPending: false,
      addTaxSlabRes: payload,
      addTaxSlabError: null,
    },
  };
};
const handleAddTaxSlabError = (state, payload) => ({
  ...state,
  ...{
    addTaxSlabPending: false,
    addTaxSlabRes: null,
    addTaxSlabError: payload,
  },
});

/* Update Tax Slab Reducers */
const handleUpdateTaxSlabRequest = state => {
  return {
    ...state,
    ...{
      updateTaxSlabPending: true,
      updateTaxSlabRes: null,
      updateTaxSlabError: null,
    },
  };
};
const handleUpdateTaxSlabSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateTaxSlabPending: false,
      updateTaxSlabRes: payload,
      updateTaxSlabError: null,
    },
  };
};
const handleUpdateTaxSlabError = (state, payload) => ({
  ...state,
  ...{
    updateTaxSlabPending: false,
    updateTaxSlabRes: null,
    updateTaxSlabError: payload,
  },
});

/* Get Tax Slab Reducers */
const handleGetTaxSlabRequest = state => {
  return {
    ...state,
    ...{
      getTaxSlabPending: true,
      getTaxSlabRes: null,
      getTaxSlabError: null,
    },
  };
};
const handleGetTaxSlabSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getTaxSlabPending: false,
      getTaxSlabRes: payload,
      getTaxSlabError: null,
    },
  };
};
const handleGetTaxSlabError = (state, payload) => ({
  ...state,
  ...{
    getTaxSlabPending: false,
    getTaxSlabRes: null,
    getTaxSlabError: payload,
  },
});

/* Get All Tax Slab Reducers */
const handleGetAllTaxSlabRequest = state => {
  return {
    ...state,
    ...{
      getAllTaxSlabPending: true,
      getAllTaxSlabRes: null,
      getAllTaxSlabError: null,
    },
  };
};
const handleGetAllTaxSlabSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllTaxSlabPending: false,
      getAllTaxSlabRes: payload,
      getAllTaxSlabError: null,
    },
  };
};
const handleGetAllTaxSlabError = (state, payload) => ({
  ...state,
  ...{
    getAllTaxSlabPending: false,
    getAllTaxSlabRes: null,
    getAllTaxSlabError: payload,
  },
});

/* Get All Tax Slab Reducers */
const handleDeleteTaxSlabRequest = state => {
  return {
    ...state,
    ...{
      deleteTaxSlabPending: true,
      deleteTaxSlabRes: null,
      deleteTaxSlabError: null,
    },
  };
};
const handleDeleteTaxSlabSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteTaxSlabPending: false,
      deleteTaxSlabRes: payload,
      deleteTaxSlabError: null,
    },
  };
};
const handleDeleteTaxSlabError = (state, payload) => ({
  ...state,
  ...{
    deleteTaxSlabPending: false,
    deleteTaxSlabRes: null,
    deleteTaxSlabError: payload,
  },
});

/* Add Employee Investment Reducers */
const handleAddEmployeeInvestmentRequest = state => {
  return {
    ...state,
    ...{
      addEmployeeInvestmentPending: true,
      addEmployeeInvestmentRes: null,
      addEmployeeInvestmentError: null,
    },
  };
};
const handleAddEmployeeInvestmentSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addEmployeeInvestmentPending: false,
      addEmployeeInvestmentRes: payload,
      addEmployeeInvestmentError: null,
    },
  };
};
const handleAddEmployeeInvestmentError = (state, payload) => ({
  ...state,
  ...{
    addEmployeeInvestmentPending: false,
    addEmployeeInvestmentRes: null,
    addEmployeeInvestmentError: payload,
  },
});

/* Get Employee Investment Reducers */
const handleGetEmployeeInvestmentRequest = state => {
  return {
    ...state,
    ...{
      getEmployeeInvestmentPending: true,
      getEmployeeInvestmentRes: null,
      getEmployeeInvestmentError: null,
    },
  };
};
const handleGetEmployeeInvestmentSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getEmployeeInvestmentPending: false,
      getEmployeeInvestmentRes: payload,
      getEmployeeInvestmentError: null,
    },
  };
};
const handleGetEmployeeInvestmentError = (state, payload) => ({
  ...state,
  ...{
    getEmployeeInvestmentPending: false,
    getEmployeeInvestmentRes: null,
    getEmployeeInvestmentError: payload,
  },
});

/* Update Employee Investment Reducers */
const handleUpdateEmployeeInvestmentRequest = state => {
  return {
    ...state,
    ...{
      updateEmployeeInvestmentPending: true,
      updateEmployeeInvestmentRes: null,
      updateEmployeeInvestmentError: null,
    },
  };
};
const handleUpdateEmployeeInvestmentSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateEmployeeInvestmentPending: false,
      updateEmployeeInvestmentRes: payload,
      updateEmployeeInvestmentError: null,
    },
  };
};
const handleUpdateEmployeeInvestmentError = (state, payload) => ({
  ...state,
  ...{
    updateEmployeeInvestmentPending: false,
    updateEmployeeInvestmentRes: null,
    updateEmployeeInvestmentError: payload,
  },
});

/* Delete Employee Investment Reducers */
const handleDeleteEmployeeInvestmentRequest = state => {
  return {
    ...state,
    ...{
      deleteEmployeeInvestmentPending: true,
      deleteEmployeeInvestmentRes: null,
      deleteEmployeeInvestmentError: null,
    },
  };
};
const handleDeleteEmployeeInvestmentSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteEmployeeInvestmentPending: false,
      deleteEmployeeInvestmentRes: payload,
      deleteEmployeeInvestmentError: null,
    },
  };
};
const handleDeleteEmployeeInvestmentError = (state, payload) => ({
  ...state,
  ...{
    deleteEmployeeInvestmentPending: false,
    deleteEmployeeInvestmentRes: null,
    deleteEmployeeInvestmentError: payload,
  },
});

/*Add Investment Category Reducers */
const handleAddInvestmentCategoryRequest = state => {

  return {
    ...state,
    ...{
      addInvestmentCategoryPending: true,
      addInvestmentCategoryRes: null,
      addInvestmentCategoryError: null,
    },
  };
};
const handleAddInvestmentCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addInvestmentCategoryPending: false,
      addInvestmentCategoryRes: payload,
      addInvestmentCategoryError: null,
    },
  };
};
const handleAddInvestmentCategoryError = (state, payload) => ({
  ...state,
  ...{
    addInvestmentCategoryPending: false,
    addInvestmentCategoryRes: null,
    addInvestmentCategoryError: payload,
  },
});

/*Update Investment Category Reducers */
const handleUpdateInvestmentCategoryRequest = state => {
  return {
    ...state,
    ...{
      updateInvestmentCategoryPending: true,
      updateInvestmentCategoryRes: null,
      updateInvestmentCategoryError: null,
    },
  };
};
const handleUpdateInvestmentCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateInvestmentCategoryPending: false,
      updateInvestmentCategoryRes: payload,
      updateInvestmentCategoryError: null,
    },
  };
};
const handleUpdateInvestmentCategoryError = (state, payload) => ({
  ...state,
  ...{
    updateInvestmentCategoryPending: false,
    updateInvestmentCategoryRes: null,
    updateInvestmentCategoryError: payload,
  },
});


/*Get Investment Category Reducers */
const handleGetInvestmentCategoryRequest = state => {
  return {
    ...state,
    ...{
      getInvestmentCategoryPending: true,
      getInvestmentCategoryRes: null,
      getInvestmentCategoryError: null,
    },
  };
};
const handleGetInvestmentCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getInvestmentCategoryPending: false,
      getInvestmentCategoryRes: payload,
      getInvestmentCategoryError: null,
    },
  };
};
const handleGetInvestmentCategoryError = (state, payload) => ({
  ...state,
  ...{
    getInvestmentCategoryPending: false,
    getInvestmentCategoryRes: null,
    getInvestmentCategoryError: payload,
  },
});

/*Get All Investment Category Reducers */
const handleGetAllInvestmentCategoryRequest = state => {
  return {
    ...state,
    ...{
      getAllInvestmentCategoryPending: true,
      getAllInvestmentCategoryRes: null,
      getAllInvestmentCategoryError: null,
    },
  };
};
const handleGetAllInvestmentCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllInvestmentCategoryPending: false,
      getAllInvestmentCategoryRes: payload,
      getAllInvestmentCategoryError: null,
    },
  };
};
const handleGetAllInvestmentCategoryError = (state, payload) => ({
  ...state,
  ...{
    getAllInvestmentCategoryPending: false,
    getAllInvestmentCategoryRes: null,
    getAllInvestmentCategoryError: payload,
  },
});

/*Delete Investment Category Reducers */
const handleDeleteInvestmentCategoryRequest = state => {
  return {
    ...state,
    ...{
      deleteInvestmentCategoryPending: true,
      deleteInvestmentCategoryRes: null,
      deleteInvestmentCategoryError: null,
    },
  };
};
const handleDeleteInvestmentCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteInvestmentCategoryPending: false,
      deleteInvestmentCategoryRes: payload,
      deleteInvestmentCategoryError: null,
    },
  };
};
const handleDeleteInvestmentCategoryError = (state, payload) => ({
  ...state,
  ...{
    deleteInvestmentCategoryPending: false,
    deleteInvestmentCategoryRes: null,
    deleteInvestmentCategoryError: payload,
  },
});


/*Add Investment Sub Category Reducers */
const handleAddInvestmentSubCategoryRequest = state => {
  return {
    ...state,
    ...{
      addInvestmentSubCategoryPending: true,
      addInvestmentSubCategoryRes: null,
      addInvestmentSubCategoryError: null,
    },
  };
};
const handleAddInvestmentSubCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addInvestmentSubCategoryPending: false,
      addInvestmentSubCategoryRes: payload,
      addInvestmentSubCategoryError: null,
    },
  };
};
const handleAddInvestmentSubCategoryError = (state, payload) => ({
  ...state,
  ...{
    addInvestmentSubCategoryPending: false,
    addInvestmentSubCategoryRes: null,
    addInvestmentSubCategoryError: payload,
  },
});


/*Update Investment Sub Category Reducers */
const handleUpdateInvestmentSubCategoryRequest = state => {
  return {
    ...state,
    ...{
      updateInvestmentSubCategoryPending: true,
      updateInvestmentSubCategoryRes: null,
      updateInvestmentSubCategoryError: null,
    },
  };
};
const handleUpdateInvestmentSubCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateInvestmentSubCategoryPending: false,
      updateInvestmentSubCategoryRes: payload,
      updateInvestmentSubCategoryError: null,
    },
  };
};
const handleUpdateInvestmentSubCategoryError = (state, payload) => ({
  ...state,
  ...{
    updateInvestmentSubCategoryPending: false,
    updateInvestmentSubCategoryRes: null,
    updateInvestmentSubCategoryError: payload,
  },
});

/*Get Investment Sub Category Reducers */
const handleGetInvestmentSubCategoryRequest = state => {
  return {
    ...state,
    ...{
      getInvestmentSubCategoryPending: true,
      getInvestmentSubCategoryRes: null,
      getInvestmentSubCategoryError: null,
    },
  };
};
const handleGetInvestmentSubCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getInvestmentSubCategoryPending: false,
      getInvestmentSubCategoryRes: payload,
      getInvestmentSubCategoryError: null,
    },
  };
};
const handleGetInvestmentSubCategoryError = (state, payload) => ({
  ...state,
  ...{
    getInvestmentSubCategoryPending: false,
    getInvestmentSubCategoryRes: null,
    getInvestmentSubCategoryError: payload,
  },
});


/*Get All Investment Sub Category Reducers */
const handleGetAllInvestmentSubCategoryRequest = state => {
  return {
    ...state,
    ...{
      getAllInvestmentSubCategoryPending: true,
      getAllInvestmentSubCategoryRes: null,
      getAllInvestmentSubCategoryError: null,
    },
  };
};
const handleGetAllInvestmentSubCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllInvestmentSubCategoryPending: false,
      getAllInvestmentSubCategoryRes: payload,
      getAllInvestmentSubCategoryError: null,
    },
  };
};
const handleGetAllInvestmentSubCategoryError = (state, payload) => ({
  ...state,
  ...{
    getAllInvestmentSubCategoryPending: false,
    getAllInvestmentSubCategoryRes: null,
    getAllInvestmentSubCategoryError: payload,
  },
});


/*Get All Investment Sub Category Reducers */
const handleDeleteInvestmentSubCategoryRequest = state => {
  return {
    ...state,
    ...{
      deleteInvestmentSubCategoryPending: true,
      deleteInvestmentSubCategoryRes: null,
      deleteInvestmentSubCategoryError: null,
    },
  };
};
const handleDeleteInvestmentSubCategorySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteInvestmentSubCategoryPending: false,
      deleteInvestmentSubCategoryRes: payload,
      deleteInvestmentSubCategoryError: null,
    },
  };
};
const handleDeleteInvestmentSubCategoryError = (state, payload) => ({
  ...state,
  ...{
    deleteInvestmentSubCategoryPending: false,
    deleteInvestmentSubCategoryRes: null,
    deleteInvestmentSubCategoryError: payload,
  },
});

/*Get All Investment Category Details Reducers */
const handleGetAllInvestmentCategoryDetailsRequest = state => {
  return {
    ...state,
    ...{
      getAllInvestmentCategoryDetailsPending: true,
      getAllInvestmentCategoryDetailsRes: null,
      getAllInvestmentCategoryDetailsError: null,
    },
  };
};
const handleGetAllInvestmentCategoryDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllInvestmentCategoryDetailsPending: false,
      getAllInvestmentCategoryDetailsRes: payload,
      getAllInvestmentCategoryDetailsError: null,
    },
  };
};
const handleGetAllInvestmentCategoryDetailsError = (state, payload) => ({
  ...state,
  ...{
    getAllInvestmentCategoryDetailsPending: false,
    getAllInvestmentCategoryDetailsRes: null,
    getAllInvestmentCategoryDetailsError: payload,
  },
});

/* Add Loans Reducers */
const handleAddLoansRequest = state => {
  return {
    ...state,
    ...{
      addLoansPending: true,
      addLoansRes: null,
      addLoansError: null,
    },
  };
};
const handleAddLoansSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addLoansPending: false,
      addLoansRes: payload,
      addLoansError: null,
    },
  };
};
const handleAddLoansError = (state, payload) => ({
  ...state,
  ...{
    addLoansPending: false,
    addLoansRes: null,
    addLoansError: payload,
  },
});

/* Update Loans Reducers */
const handleUpdateLoansRequest = state => {
  return {
    ...state,
    ...{
      updateLoansPending: true,
      updateLoansRes: null,
      updateLoansError: null,
    },
  };
};
const handleUpdateLoansSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateLoansPending: false,
      updateLoansRes: payload,
      updateLoansError: null,
    },
  };
};
const handleUpdateLoansError = (state, payload) => ({
  ...state,
  ...{
    updateLoansPending: false,
    updateLoansRes: null,
    updateLoansError: payload,
  },
});

/* Get Loans Reducers */
const handleGetLoansRequest = state => {
  return {
    ...state,
    ...{
      getLoansPending: true,
      getLoansRes: null,
      getLoansError: null,
    },
  };
};
const handleGetLoansSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getLoansPending: false,
      getLoansRes: payload,
      getLoansError: null,
    },
  };
};
const handleGetLoansError = (state, payload) => ({
  ...state,
  ...{
    getLoansPending: false,
    getLoansRes: null,
    getLoansError: payload,
  },
});


/* Apply Advance Reducers */
const handleApplyAdvanceRequest = state => {
  return {
    ...state,
    ...{
      applyAdvancePending: true,
      applyAdvanceRes: null,
      applyAdvanceError: null,
    },
  };
};
const handleApplyAdvanceSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      applyAdvancePending: false,
      applyAdvanceRes: payload,
      applyAdvanceError: null,
    },
  };
};
const handleApplyAdvanceError = (state, payload) => ({
  ...state,
  ...{
    applyAdvancePending: false,
    applyAdvanceRes: null,
    applyAdvanceError: payload,
  },
});

const handleGetAdvanceApprovalRequest = state => {
  return {
    ...state,
    ...{
      getAdvanceApprovalPending: true,
      getAdvanceApprovalRes: null,
      getAdvanceApprovalError: null,
    },
  };
};
const handleGetAdvanceApprovalSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAdvanceApprovalPending: false,
      getAdvanceApprovalRes: payload,
      getAdvanceApprovalError: null,
    },
  };
};
const handleGetAdvanceApprovalError = (state, payload) => ({
  ...state,
  ...{
    getAdvanceApprovalPending: false,
    getAdvanceApprovalRes: null,
    getAdvanceApprovalError: payload,
  },
});


const handleGetAdvanceRequestRequest = state => {
  return {
    ...state,
    ...{
      getAdvanceRequestPending: true,
      getAdvanceRequestRes: null,
      getAdvanceRequestError: null,
    },
  };
};
const handleGetAdvanceRequestSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAdvanceRequestPending: false,
      getAdvanceRequestRes: payload,
      getAdvanceRequestError: null,
    },
  };
};
const handleGetAdvanceRequestError = (state, payload) => ({
  ...state,
  ...{
    getAdvanceRequestPending: false,
    getAdvanceRequestRes: null,
    getAdvanceRequestError: payload,
  },
});

const handleApprovalRejectAdvanceRequest = state => {
  return {
    ...state,
    ...{
      approvalRejectAdvancePending: true,
      approvalRejectAdvanceRes: null,
      approvalRejectAdvanceError: null,
    },
  };
};
const handleApprovalRejectAdvanceSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      approvalRejectAdvancePending: false,
      approvalRejectAdvanceRes: payload,
      approvalRejectAdvanceError: null,
    },
  };
};
const handleApprovalRejectAdvanceError = (state, payload) => ({
  ...state,
  ...{
    approvalRejectAdvancePending: false,
    approvalRejectAdvanceRes: null,
    approvalRejectAdvanceError: payload,
  },
});

/* Check Rule Formula Reducers */
const handleCheckRuleFormulaRequest = state => {
  return {
    ...state,
    ...{
      checkRuleFormulaPending: true,
      checkRuleFormulaRes: null,
      checkRuleFormulaError: null,
    },
  };
};
const handleCheckRuleFormulaSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      checkRuleFormulaPending: false,
      checkRuleFormulaRes: payload,
      checkRuleFormulaError: null,
    },
  };
};
const handleCheckRuleFormulaError = (state, payload) => ({
  ...state,
  ...{
    checkRuleFormulaPending: false,
    checkRuleFormulaRes: null,
    checkRuleFormulaError: payload,
  },
});

/* Employee Investment Proof Reducers */
const handleEmployeeInvestmentProofRequest = state => {
  return {
    ...state,
    ...{
      employeeInvestmentProofPending: true,
      employeeInvestmentProofRes: null,
      employeeInvestmentProofError: null,
    },
  };
};
const handleEmployeeInvestmentProofSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      employeeInvestmentProofPending: false,
      employeeInvestmentProofRes: payload,
      employeeInvestmentProofError: null,
    },
  };
};
const handleEmployeeInvestmentProofError = (state, payload) => ({
  ...state,
  ...{
    employeeInvestmentProofPending: false,
    employeeInvestmentProofRes: null,
    employeeInvestmentProofError: payload,
  },
});

/* Get Employee Investment Proof Reducers */
const handleGetEmployeeInvestmentProofRequest = state => {
  return {
    ...state,
    ...{
      getEmployeeInvestmentProofPending: true,
      getEmployeeInvestmentProofRes: null,
      getEmployeeInvestmentProofError: null,
    },
  };
};
const handleGetEmployeeInvestmentProofSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getEmployeeInvestmentProofPending: false,
      getEmployeeInvestmentProofRes: payload,
      getEmployeeInvestmentProofError: null,
    },
  };
};
const handleGetEmployeeInvestmentProofError = (state, payload) => ({
  ...state,
  ...{
    getEmployeeInvestmentProofPending: false,
    getEmployeeInvestmentProofRes: null,
    getEmployeeInvestmentProofError: payload,
  },
});

/* Get Employee Investment Proof Reducers */
const handleUpdateEmployeeInvestmentProofRequest = state => {
  return {
    ...state,
    ...{
      updateEmployeeInvestmentProofPending: true,
      updateEmployeeInvestmentProofRes: null,
      updateEmployeeInvestmentProofError: null,
    },
  };
};
const handleUpdateEmployeeInvestmentProofSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateEmployeeInvestmentProofPending: false,
      updateEmployeeInvestmentProofRes: payload,
      updateEmployeeInvestmentProofError: null,
    },
  };
};
const handleUpdateEmployeeInvestmentProofError = (state, payload) => ({
  ...state,
  ...{
    updateEmployeeInvestmentProofPending: false,
    updateEmployeeInvestmentProofRes: null,
    updateEmployeeInvestmentProofError: payload,
  },
});

/* Delete Employee Investment Proof Reducers */
const handleDeleteEmployeeInvestmentProofRequest = state => {
  return {
    ...state,
    ...{
      deleteEmployeeInvestmentProofPending: true,
      deleteEmployeeInvestmentProofRes: null,
      deleteEmployeeInvestmentProofError: null,
    },
  };
};
const handleDeleteEmployeeInvestmentProofSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteEmployeeInvestmentProofPending: false,
      deleteEmployeeInvestmentProofRes: payload,
      deleteEmployeeInvestmentProofError: null,
    },
  };
};
const handleDeleteEmployeeInvestmentProofError = (state, payload) => ({
  ...state,
  ...{
    deleteEmployeeInvestmentProofPending: false,
    deleteEmployeeInvestmentProofRes: null,
    deleteEmployeeInvestmentProofError: payload,
  },
});


/* Comment In Employee Investment Proof Reducers */
const handleCommentInEmployeeInvestmentProofRequest = state => {
  return {
    ...state,
    ...{
      commentInEmployeeInvestmentProofPending: true,
      commentInEmployeeInvestmentProofRes: null,
      commentInEmployeeInvestmentProofError: null,
    },
  };
};
const handleCommentInEmployeeInvestmentProofSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      commentInEmployeeInvestmentProofPending: false,
      commentInEmployeeInvestmentProofRes: payload,
      commentInEmployeeInvestmentProofError: null,
    },
  };
};
const handleCommentInEmployeeInvestmentProofError = (state, payload) => ({
  ...state,
  ...{
    commentInEmployeeInvestmentProofPending: false,
    commentInEmployeeInvestmentProofRes: null,
    commentInEmployeeInvestmentProofError: payload,
  },
});

/* get All Employee Salary Reducers */
const handleGetAllEmployeeSalaryRequest = state => {
  return {
    ...state,
    ...{
      getAllEmployeeSalaryPending: true,
      getAllEmployeeSalaryRes: null,
      getAllEmployeeSalaryError: null,
    },
  };
};
const handleGetAllEmployeeSalarySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllEmployeeSalaryPending: false,
      getAllEmployeeSalaryRes: payload,
      getAllEmployeeSalaryError: null,
    },
  };
};
const handleGetAllEmployeeSalaryError = (state, payload) => ({
  ...state,
  ...{
    getAllEmployeeSalaryPending: false,
    getAllEmployeeSalaryRes: null,
    getAllEmployeeSalaryError: payload,
  },
});

/* Get Employee Monthly Salary Reducers */
const handleGetEmployeeMonthlySalaryRequest = state => {
  return {
    ...state,
    ...{
      getEmployeeMonthlySalaryPending: true,
      getEmployeeMonthlySalaryRes: null,
      getEmployeeMonthlySalaryError: null,
    },
  };
};
const handleGetEmployeeMonthlySalarySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getEmployeeMonthlySalaryPending: false,
      getEmployeeMonthlySalaryRes: payload,
      getEmployeeMonthlySalaryError: null,
    },
  };
};
const handleGetEmployeeMonthlySalaryError = (state, payload) => ({
  ...state,
  ...{
    getEmployeeMonthlySalaryPending: false,
    getEmployeeMonthlySalaryRes: null,
    getEmployeeMonthlySalaryError: payload,
  },
});

/* Generate Salary Slip Reducers */
const handleGenerateSalarySlipRequest = state => {
  return {
    ...state,
    ...{
      generateSalarySlipPending: true,
      generateSalarySlipRes: null,
      generateSalarySlipError: null,
    },
  };
};
const handleGenerateSalarySlipSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      generateSalarySlipPending: false,
      generateSalarySlipRes: payload,
      generateSalarySlipError: null,
    },
  };
};
const handleGenerateSalarySlipError = (state, payload) => ({
  ...state,
  ...{
    generateSalarySlipPending: false,
    generateSalarySlipRes: null,
    generateSalarySlipError: payload,
  },
});

/* Send Offer Letter Reducers */
const handleSendOfferLetterRequest = state => {
  return {
    ...state,
    ...{
      sendOfferLetterPending: true,
      sendOfferLetterRes: null,
      sendOfferLetterError: null,
    },
  };
};
const handleSendOfferLetterSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      sendOfferLetterPending: false,
      sendOfferLetterRes: payload,
      sendOfferLetterError: null,
    },
  };
};
const handleSendOfferLetterError = (state, payload) => ({
  ...state,
  ...{
    sendOfferLetterPending: false,
    sendOfferLetterRes: null,
    sendOfferLetterError: payload,
  },
});

/*Get Candidate Salary Reducers */
const handleGetCandidateSalaryRequest = state => {
  return {
    ...state,
    ...{
      getCandidateSalaryPending: true,
      getCandidateSalaryRes: null,
      getCandidateSalaryError: null,
    },
  };
};
const handleGetCandidateSalarySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getCandidateSalaryPending: false,
      getCandidateSalaryRes: payload,
      getCandidateSalaryError: null,
    },
  };
};
const handleGetCandidateSalaryError = (state, payload) => ({
  ...state,
  ...{
    getCandidateSalaryPending: false,
    getCandidateSalaryRes: null,
    getCandidateSalaryError: payload,
  },
});

/*Get Candidate Salary Reducers */
const handleUpdateEmployeeMonthlySalaryRequest = state => {
  return {
    ...state,
    ...{
      updateEmployeeMonthlySalaryPending: true,
      updateEmployeeMonthlySalaryRes: null,
      updateEmployeeMonthlySalaryError: null,
    },
  };
};
const handleUpdateEmployeeMonthlySalarySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateEmployeeMonthlySalaryPending: false,
      updateEmployeeMonthlySalaryRes: payload,
      updateEmployeeMonthlySalaryError: null,
    },
  };
};
const handleUpdateEmployeeMonthlySalaryError = (state, payload) => ({
  ...state,
  ...{
    updateEmployeeMonthlySalaryPending: false,
    updateEmployeeMonthlySalaryRes: null,
    updateEmployeeMonthlySalaryError: payload,
  },
});

/*Get Candidate Salary Reducers */
const handleDeleteEarningTypeRequest = state => {
  return {
    ...state,
    ...{
      deleteEarningTypePending: true,
      deleteEarningTypeRes: null,
      deleteEarningTypeError: null,
    },
  };
};
const handleDeleteEarningTypeSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteEarningTypePending: false,
      deleteEarningTypeRes: payload,
      deleteEarningTypeError: null,
    },
  };
};
const handleDeleteEarningTypeError = (state, payload) => ({
  ...state,
  ...{
    deleteEarningTypePending: false,
    deleteEarningTypeRes: null,
    deleteEarningTypeError: payload,
  },
});

/*Get Candidate Salary Reducers */
const handleDeleteEarningRequest = state => {
  return {
    ...state,
    ...{
      deleteEarningPending: true,
      deleteEarningRes: null,
      deleteEarningError: null,
    },
  };
};
const handleDeleteEarningSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteEarningPending: false,
      deleteEarningRes: payload,
      deleteEarningError: null,
    },
  };
};
const handleDeleteEarningError = (state, payload) => ({
  ...state,
  ...{
    deleteEarningPending: false,
    deleteEarningRes: null,
    deleteEarningError: payload,
  },
});

/*Get Candidate Salary Reducers */
const handleDeleteDeductionRequest = state => {
  return {
    ...state,
    ...{
      deleteDeductionPending: true,
      deleteDeductionRes: null,
      deleteDeductionError: null,
    },
  };
};
const handleDeleteDeductionSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteDeductionPending: false,
      deleteDeductionRes: payload,
      deleteDeductionError: null,
    },
  };
};
const handleDeleteDeductionError = (state, payload) => ({
  ...state,
  ...{
    deleteDeductionPending: false,
    deleteDeductionRes: null,
    deleteDeductionError: payload,
  },
});



/*Get Candidate Salary Reducers */
const handleDeleteDeductionTypeRequest = state => {
  return {
    ...state,
    ...{
      deleteDeductionTypePending: true,
      deleteDeductionTypeRes: null,
      deleteDeductionTypeError: null,
    },
  };
};
const handleDeleteDeductionTypeSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteDeductionTypePending: false,
      deleteDeductionTypeRes: payload,
      deleteDeductionTypeError: null,
    },
  };
};
const handleDeleteDeductionTypeError = (state, payload) => ({
  ...state,
  ...{
    deleteDeductionTypePending: false,
    deleteDeductionTypeRes: null,
    deleteDeductionTypeError: payload,
  },
});


/*Get Candidate Salary Reducers */
const handleDeleteSalaryTemplateRequest = state => {
  return {
    ...state,
    ...{
      deleteSalaryTemplatePending: true,
      deleteSalaryTemplateRes: null,
      deleteSalaryTemplateError: null,
    },
  };
};
const handleDeleteSalaryTemplateSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteSalaryTemplatePending: false,
      deleteSalaryTemplateRes: payload,
      deleteSalaryTemplateError: null,
    },
  };
};
const handleDeleteSalaryTemplateError = (state, payload) => ({
  ...state,
  ...{
    deleteSalaryTemplatePending: false,
    deleteSalaryTemplateRes: null,
    deleteSalaryTemplateError: payload,
  },
});

/*Get Candidate Salary Reducers */
const handleGetEmployeeMonthlyPaySlipRequest = state => {
  return {
    ...state,
    ...{
      getEmployeeMonthlyPaySlipPending: true,
      getEmployeeMonthlyPaySlipRes: null,
      getEmployeeMonthlyPaySlipError: null,
    },
  };
};
const handleGetEmployeeMonthlyPaySlipSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getEmployeeMonthlyPaySlipPending: false,
      getEmployeeMonthlyPaySlipRes: payload,
      getEmployeeMonthlyPaySlipError: null,
    },
  };
};
const handleGetEmployeeMonthlyPaySlipError = (state, payload) => ({
  ...state,
  ...{
    getEmployeeMonthlyPaySlipPending: false,
    getEmployeeMonthlyPaySlipRes: null,
    getEmployeeMonthlyPaySlipError: payload,
  },
});




/* Selected Employee Data Reducers */
const handleSelectedEmployeeData = (state, payload) => ({
  ...state,
  ...{
    selectedEmployeeData: payload,
  }

});
/* Selected Employee Data Reducers */
const handleActionType = (state, payload) => ({
  ...state,
  ...{
    actionType: payload,
  }

});

// Clear Existing Data Store Reducers*/
const clearPayrollStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_UPDATE_ATTENDANCE_TRACKING_STORE':
      return {
        ...state,
        ...{
          updateAttendanceTrackingPending: false,
          updateAttendanceTrackingRes: null,
          updateAttendanceTrackingError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_EARNING_TYPE_STORE':
      return {
        ...state,
        ...{
          addEarningTypesPending: false,
          addEarningTypesRes: null,
          addEarningTypesError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_EARNING_TYPE_STORE':
      return {
        ...state,
        ...{
          updateEarningTypesPending: false,
          updateEarningTypesRes: null,
          updateEarningTypesError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_EARNING_STORE':
      return {
        ...state,
        ...{
          addEarningsPending: false,
          addEarningsRes: null,
          addEarningsError: null,

        },
      };
    case 'HANDLE_CLEAR_UPDATE_EARNING_STORE':
      return {
        ...state,
        ...{
          updateEarningsPending: false,
          updateEarningsRes: null,
          updateEarningsError: null,

        },
      };
    case 'HANDLE_CLEAR_ADD_DEDUCTIONS_STORE':
      return {
        ...state,
        ...{
          addDeductionsPending: false,
          addDeductionsRes: null,
          addDeductionsError: null,

        },
      };
    case 'HANDLE_CLEAR_UPDATE_DEDUCTIONS_STORE':
      return {
        ...state,
        ...{
          updateDeductionsPending: false,
          updateDeductionsRes: null,
          updateDeductionsError: null,

        },
      };
    case 'HANDLE_CLEAR_EARNING_TYPE_BY_ID_STORE':
      return {
        ...state,
        ...{
          getEarningTypeByIdPending: false,
          getEarningTypeByIdRes: null,
          getEarningTypeByIdError: null,

        },
      };
    case 'HANDLE_CLEAR_ADD_DEDUCTION_TYPE_STORE':
      return {
        ...state,
        ...{
          addDeductionTypesPending: false,
          addDeductionTypesRes: null,
          addDeductionTypesError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_DEDUCTION_TYPE_STORE':
      return {
        ...state,
        ...{
          updateDeductionTypesPending: false,
          updateDeductionTypesRes: null,
          updateDeductionTypesError: null,
        },
      };
    case 'HANDLE_CLEAR_DEDUCTION_TYPE_BY_ID_STORE':
      return {
        ...state,
        ...{
          getDeductionTypeByIdPending: false,
          getDeductionTypeByIdRes: null,
          getDeductionTypeByIdError: null,

        },
      };
    case 'HANDLE_CLEAR_SAVE_SALARY_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          saveSalaryTemplatePending: false,
          saveSalaryTemplateRes: null,
          saveSalaryTemplateError: null,

        },
      };
    case 'HANDLE_CLEAR_UPDATE_SALARY_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          updateSalaryTemplatePending: false,
          updateSalaryTemplateRes: null,
          updateSalaryTemplateError: null,

        },
      };
    case 'HANDLE_CALCULATE_CTC_STORE':
      return {
        ...state,
        ...{
          calculateCtcPending: false,
          calculateCtcRes: null,
          calculateCtcError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_EMPLOYEE_SALARY_STORE':
      return {
        ...state,
        ...{
          addEmployeeSalaryPending: false,
          addEmployeeSalaryRes: null,
          addEmployeeSalaryError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_EMPLOYEE_SALARY_STORE':
      return {
        ...state,
        ...{
          updateEmployeeSalaryPending: false,
          updateEmployeeSalaryRes: null,
          updateEmployeeSalaryError: null,
        },
      };
    case 'HANDLE_CLEAR_ALL_SALARY_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          getAllSalaryTemplatePending: false,
          getAllSalaryTemplateRes: null,
          getAllSalaryTemplateError: null,
        },
      };

    case 'HANDLE_CLEAR_GET_SALARY_TEMPLATE_BY_ID_STORE':
      return {
        ...state,
        ...{
          getSalaryTemplateByIdPending: false,
          getSalaryTemplateByIdRes: null,
          getSalaryTemplateByIdError: null,
        },
      };
    case 'HANDLE_CLEAR_GENERATE_SALARY_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          generateSalaryTemplatePending: false,
          generateSalaryTemplateRes: null,
          generateSalaryTemplateError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_ARREARS_STORE':
      return {
        ...state,
        ...{
          addArrearsPending: false,
          addArrearsRes: null,
          addArrearsError: null,
        },
      };

    case 'HANDLE_CLEAR_ADD_PAY_RUN_STORE':
      return {
        ...state,
        ...{
          addPayRunPending: false,
          addPayRunRes: null,
          addPayRunError: null,
        },
      };

    case 'HANDLE_CLEAR_ADD_TAX_SLAB_STORE':
      return {
        ...state,
        ...{
          addTaxSlabPending: false,
          addTaxSlabRes: null,
          addTaxSlabError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_TAX_SLAB_STORE':
      return {
        ...state,
        ...{
          updateTaxSlabPending: false,
          updateTaxSlabRes: null,
          updateTaxSlabError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_TAX_SLAB_STORE':
      return {
        ...state,
        ...{
          deleteTaxSlabPending: false,
          deleteTaxSlabRes: null,
          deleteTaxSlabError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_PAY_SCHEDULE_STORE':
      return {
        ...state,
        ...{
          addPaySchedulePending: false,
          addPayScheduleRes: null,
          addPayScheduleError: null,

        },
      };
    case 'HANDLE_CLEAR_UPDATE_PAY_SCHEDULE_STORE':
      return {
        ...state,
        ...{
          updatePaySchedulePending: false,
          updatePayScheduleRes: null,
          updatePayScheduleError: null,

        },
      };
    case 'HANDLE_CLEAR_UPCOMING_PAY_ROLL_STORE':
      return {
        ...state,
        ...{
          upcomingPayrollsPending: false,
          upcomingPayrollsRes: null,
          upcomingPayrollsError: null,

        },
      };
    case 'HANDLE_CLEAR_ADD_EMPLOYEE_INVESTMENT_STORE':
      return {
        ...state,
        ...{
          addEmployeeInvestmentPending: false,
          addEmployeeInvestmentRes: null,
          addEmployeeInvestmentError: null,

        },
      };
    case 'HANDLE_CLEAR_UPDATE_EMPLOYEE_INVESTMENT_STORE':
      return {
        ...state,
        ...{
          updateEmployeeInvestmentPending: false,
          updateEmployeeInvestmentRes: null,
          updateEmployeeInvestmentError: null,

        },
      };
    case 'HANDLE_CLEAR_DELETE_EMPLOYEE_INVESTMENT_STORE':
      return {
        ...state,
        ...{
          deleteEmployeeInvestmentPending: false,
          deleteEmployeeInvestmentRes: null,
          deleteEmployeeInvestmentError: null,

        },
      };

    case 'HANDLE_CLEAR_ADD_LOAN_STORE':
      return {
        ...state,
        ...{
          addLoansPending: false,
          addLoansRes: null,
          addLoansError: null,

        },
      };

    case 'HANDLE_CLEAR_UPDATE_LOAN_STORE':
      return {
        ...state,
        ...{
          updateLoansPending: false,
          updateLoansRes: null,
          updateLoansError: null,

        },
      };
    case 'HANDLE_CLEAR_GET_LOAN_STORE':
      return {
        ...state,
        ...{
          getLoansPending: false,
          getLoansRes: null,
          getLoansError: null,

        },
      };
    case 'HANDLE_CLEAR_CHECK_RULE_STORE':
      return {
        ...state,
        ...{
          checkRuleFormulaPending: false,
          checkRuleFormulaRes: null,
          checkRuleFormulaError: null,

        },
      };
    case 'HANDLE_ADD_INVESTMENT_CATEGORY_STORE':
      return {
        ...state,
        ...{
          addInvestmentCategoryPending: false,
          addInvestmentCategoryRes: null,
          addInvestmentCategoryError: null,

        },
      };
    case 'HANDLE_UPDATE_INVESTMENT_CATEGORY_STORE':
      return {
        ...state,
        ...{
          updateInvestmentCategoryPending: false,
          updateInvestmentCategoryRes: null,
          updateInvestmentCategoryError: null,

        },
      };
    case 'HANDLE_GET_INVESTMENT_CATEGORY_STORE':
      return {
        ...state,
        ...{
          getInvestmentCategoryPending: false,
          getInvestmentCategoryRes: null,
          getInvestmentCategoryError: null,

        },
      };
    case 'HANDLE_GET_ALL_INVESTMENT_CATEGORY_STORE':
      return {
        ...state,
        ...{
          getAllInvestmentCategoryPending: false,
          getAllInvestmentCategoryRes: null,
          getAllInvestmentCategoryError: null,

        },
      };
    case 'HANDLE_DELETE_INVESTMENT_CATEGORY_STORE':
      return {
        ...state,
        ...{
          deleteInvestmentCategoryPending: false,
          deleteInvestmentCategoryRes: null,
          deleteInvestmentCategoryError: null,

        },
      };
    case 'HANDLE_ADD_INVESTMENT_SUB_CATEGORY_STORE':
      return {
        ...state,
        ...{
          addInvestmentSubCategoryPending: false,
          addInvestmentSubCategoryRes: null,
          addInvestmentSubCategoryError: null,

        },
      };
    case 'HANDLE_UPDATE_INVESTMENT_SUB_CATEGORY_STORE':
      return {
        ...state,
        ...{
          updateInvestmentSubCategoryPending: false,
          updateInvestmentSubCategoryRes: null,
          updateInvestmentSubCategoryError: null,

        },
      };
    case 'HANDLE_GET_INVESTMENT_SUB_CATEGORY_STORE':
      return {
        ...state,
        ...{
          getInvestmentSubCategoryPending: false,
          getInvestmentSubCategoryRes: null,
          getInvestmentSubCategoryError: null,

        },
      };
    case 'HANDLE_GET_ALL_INVESTMENT_SUB_CATEGORY_STORE':
      return {
        ...state,
        ...{
          getAllInvestmentSubCategoryPending: false,
          getAllInvestmentSubCategoryRes: null,
          getAllInvestmentSubCategoryError: null,

        },
      };
    case 'HANDLE_DELETE_INVESTMENT_SUB_CATEGORY_STORE':
      return {
        ...state,
        ...{
          deleteInvestmentSubCategoryPending: false,
          deleteInvestmentSubCategoryRes: null,
          deleteInvestmentSubCategoryError: null,

        },
      };
    case 'HANDLE_CLEAR_APPLY_ADVANCE_STORE':
      return {
        ...state,
        ...{
          applyAdvancePending: false,
          applyAdvanceRes: null,
          applyAdvanceError: null,

        },
      };
    case 'HANDLE_CLEAR_EMPLOYEE_INVESTMENT_PROOF_STORE':
      return {
        ...state,
        ...{
          employeeInvestmentProofPending: false,
          employeeInvestmentProofRes: null,
          employeeInvestmentProofError: null,

        },
      };
    case 'HANDLE_CLEAR_UPDATE_EMPLOYEE_INVESTMENT_PROOF_STORE':
      return {
        ...state,
        ...{
          updateEmployeeInvestmentProofPending: false,
          updateEmployeeInvestmentProofRes: null,
          updateEmployeeInvestmentProofError: null,

        },
      };

    case 'HANDLE_CLEAR_DELETE_EMPLOYEE_INVESTMENT_PROOF_STORE':
      return {
        ...state,
        ...{
          deleteEmployeeInvestmentProofPending: false,
          deleteEmployeeInvestmentProofRes: null,
          deleteEmployeeInvestmentProofError: null,

        },
      };
    case 'HANDLE_CLEAR_EMPLOYEE_MONTHLY_SALARY_STORE':
      return {
        ...state,
        ...{
          getEmployeeMonthlySalaryPending: false,
          getEmployeeMonthlySalaryRes: null,
          getEmployeeMonthlySalaryError: null,

        },
      };
    case 'HANDLE_CLEAR_GENERATE_SALARY_SLIP_STORE':
      return {
        ...state,
        ...{
          generateSalarySlipPending: false,
          generateSalarySlipRes: null,
          generateSalarySlipError: null,

        },
      };
    case 'HANDLE_CLEAR_SEND_OFFER_LETTER_STORE':
      return {
        ...state,
        ...{
          sendOfferLetterPending: false,
          sendOfferLetterRes: null,
          sendOfferLetterError: null,

        },
      };
    case 'HANDLE_CLEAR_GET_CANDIDATE_SALARY_STORE':
      return {
        ...state,
        ...{
          getCandidateSalaryPending: false,
          getCandidateSalaryRes: null,
          getCandidateSalaryError: null,

        },
      };
    case 'HANDLE_CLEAR_APPROVAE_PAYROLL_STORE':
      return {
        ...state,
        ...{
          approvePayrollPending: false,
          approvePayrollRes: null,
          approvePayrollError: null,

        },
      };

    case 'HANDLE_CLEAR_UPDATE_EMPLOYEE_MONTHLY_SALARY_STORE':
      return {
        ...state,
        ...{
          updateEmployeeMonthlySalaryPending: false,
          updateEmployeeMonthlySalaryRes: null,
          updateEmployeeMonthlySalaryError: null,

        },
      };

    case 'HANDLE_CLEAR_DELETE_EARNING_STORE':
      return {
        ...state,
        ...{
          deleteEarningPending: false,
          deleteEarningRes: null,
          deleteEarningError: null,

        },
      };
    case 'HANDLE_DELETE_EARNING_TYPE_STORE':
      return {
        ...state,
        ...{
          deleteEarningTypePending: false,
          deleteEarningTypeRes: null,
          deleteEarningTypeError: null,

        },
      };
    case 'HANDLE_DELETE_DEDUCTION_STORE':
      return {
        ...state,
        ...{
          deleteDeductionPending: false,
          deleteDeductionRes: null,
          deleteDeductionError: null,
        },
      };
    case 'HANDLE_DELETE_DEDUCTION_TYPE_STORE':
      return {
        ...state,
        ...{
          deleteDeductionTypePending: false,
          deleteDeductionTypeRes: null,
          deleteDeductionTypeError: null,
        },
      };
    case 'HANDLE_DELETE_SALARY_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          deleteSalaryTemplatePending: false,
          deleteSalaryTemplateRes: null,
          deleteSalaryTemplateError: null,

        },
      };
    case 'HANDLE_CLEAR_GET_EMPLOYEE_MONTHLY_PAYSLIP_STORE':
      return {
        ...state,
        ...{
          getEmployeeMonthlyPaySlipPending: false,
          getEmployeeMonthlyPaySlipRes: null,
          getEmployeeMonthlyPaySlipError: null,

        },
      };
    case 'HANDLE_CLEAR_ACTION_TYPE_STORE':
      return {
        ...state,
        ...{
          actionType: null,

        },
      };

    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.getEmployeeDetailsByPayDaysRequest]: handleGetEmployeeDetailsByPayDaysRequest,
    [actions.getEmployeeDetailsByPayDaysSuccess]: handleGetEmployeeDetailsByPayDaysSuccess,
    [actions.getEmployeeDetailsByPayDaysError]: handleGetEmployeeDetailsByPayDaysError,

    [actions.getAttendanceStatusRequest]: handleGetAttendanceStatusRequest,
    [actions.getAttendanceStatusSuccess]: handleGetAttendanceStatusSuccess,
    [actions.getAttendanceStatusError]: handleGetAttendanceStatusError,

    [actions.updateAttendanceTrackingRequest]: handleUpdateAttendanceTrackingRequest,
    [actions.updateAttendanceTrackingSuccess]: handleUpdateAttendanceTrackingSuccess,
    [actions.updateAttendanceTrackingError]: handleUpdateAttendanceTrackingError,

    [actions.addEarningsRequest]: handleAddEarningsRequest,
    [actions.addEarningsSuccess]: handleAddEarningsSuccess,
    [actions.addEarningsError]: handleAddEarningsError,

    [actions.updateEarningsRequest]: handleUpdateEarningsRequest,
    [actions.updateEarningsSuccess]: handleUpdateEarningsSuccess,
    [actions.updateEarningsError]: handleUpdateEarningsError,

    [actions.getEarningsRequest]: handleGetEarningsRequest,
    [actions.getEarningsSuccess]: handleGetEarningsSuccess,
    [actions.getEarningsError]: handleGetEarningsError,

    [actions.addDeductionsRequest]: handleAddDeductionsRequest,
    [actions.addDeductionsSuccess]: handleAddDeductionsSuccess,
    [actions.addDeductionsError]: handleAddDeductionsError,

    [actions.updateDeductionsRequest]: handleUpdateDeductionsRequest,
    [actions.updateDeductionsSuccess]: handleUpdateDeductionsSuccess,
    [actions.updateDeductionsError]: handleUpdateDeductionsError,

    [actions.getDeductionsRequest]: handleGetDeductionsRequest,
    [actions.getDeductionsSuccess]: handleGetDeductionsSuccess,
    [actions.getDeductionsError]: handleGetDeductionsError,

    [actions.addTaxSlabsRequest]: handleAddTaxSlabsRequest,
    [actions.addTaxSlabsSuccess]: handleAddTaxSlabsSuccess,
    [actions.addTaxSlabsError]: handleAddTaxSlabsError,

    [actions.addEarningTypesRequest]: handleAddEarningTypesRequest,
    [actions.addEarningTypesSuccess]: handleAddEarningTypesSuccess,
    [actions.addEarningTypesError]: handleAddEarningTypesError,

    [actions.updateEarningTypesRequest]: handleUpdateEarningTypesRequest,
    [actions.updateEarningTypesSuccess]: handleUpdateEarningTypesSuccess,
    [actions.updateEarningTypesError]: handleUpdateEarningTypesError,

    [actions.getEarningTypeRequest]: handleGetEarningTypeRequest,
    [actions.getEarningTypeSuccess]: handleGetEarningTypeSuccess,
    [actions.getEarningTypeError]: handleGetEarningTypeError,

    [actions.getAllEarningTypeRequest]: handleGetAllEarningTypeRequest,
    [actions.getAllEarningTypeSuccess]: handleGetAllEarningTypeSuccess,
    [actions.getAllEarningTypeError]: handleGetAllEarningTypeError,

    [actions.getEarningTypeByIdRequest]: handleGetEarningTypeByIdRequest,
    [actions.getEarningTypeByIdSuccess]: handleGetEarningTypeByIdSuccess,
    [actions.getEarningTypeByIdError]: handleGetEarningTypeByIdError,

    [actions.addDeductionTypesRequest]: handleAddDeductionTypesRequest,
    [actions.addDeductionTypesSuccess]: handleAddDeductionTypesSuccess,
    [actions.addDeductionTypesError]: handleAddDeductionTypesError,

    [actions.updateDeductionTypesRequest]: handleUpdateDeductionTypesRequest,
    [actions.updateDeductionTypesSuccess]: handleUpdateDeductionTypesSuccess,
    [actions.updateDeductionTypesError]: handleUpdateDeductionTypesError,

    [actions.getDeductionTypeRequest]: handleGetDeductionTypeRequest,
    [actions.getDeductionTypeSuccess]: handleGetDeductionTypeSuccess,
    [actions.getDeductionTypeError]: handleGetDeductionTypeError,

    [actions.getAllDeductionTypeRequest]: handleGetAllDeductionTypeRequest,
    [actions.getAllDeductionTypeSuccess]: handleGetAllDeductionTypeSuccess,
    [actions.getAllDeductionTypeError]: handleGetAllDeductionTypeError,

    [actions.getDeductionTypeByIdRequest]: handleGetDeductionTypeByIdRequest,
    [actions.getDeductionTypeByIdSuccess]: handleGetDeductionTypeByIdSuccess,
    [actions.getDeductionTypeByIdError]: handleGetDeductionTypeByIdError,

    [actions.generateSalaryTemplateRequest]: handleGenerateSalaryTemplateRequest,
    [actions.generateSalaryTemplateSuccess]: handleGenerateSalaryTemplateSuccess,
    [actions.generateSalaryTemplateError]: handleGenerateSalaryTemplateError,

    [actions.saveSalaryTemplateRequest]: handleSaveSalaryTemplateRequest,
    [actions.saveSalaryTemplateSuccess]: handleSaveSalaryTemplateSuccess,
    [actions.saveSalaryTemplateError]: handleSaveSalaryTemplateError,

    [actions.getAllSalaryTemplateRequest]: handleGetAllSalaryTemplateRequest,
    [actions.getAllSalaryTemplateSuccess]: handleGetAllSalaryTemplateSuccess,
    [actions.getAllSalaryTemplateError]: handleGetAllSalaryTemplateError,

    [actions.getSalaryTemplateRequest]: handleGetSalaryTemplateRequest,
    [actions.getSalaryTemplateSuccess]: handleGetSalaryTemplateSuccess,
    [actions.getSalaryTemplateError]: handleGetSalaryTemplateError,

    [actions.updateSalaryTemplateRequest]: handleUpdateSalaryTemplateRequest,
    [actions.updateSalaryTemplateSuccess]: handleUpdateSalaryTemplateSuccess,
    [actions.updateSalaryTemplateError]: handleUpdateSalaryTemplateError,

    [actions.getSalaryTemplateByIdRequest]: handleGetSalaryTemplateByIdRequest,
    [actions.getSalaryTemplateByIdSuccess]: handleGetSalaryTemplateByIdSuccess,
    [actions.getSalaryTemplateByIdError]: handleGetSalaryTemplateByIdError,

    [actions.getAllEarningRequest]: handleGetAllEarningRequest,
    [actions.getAllEarningSuccess]: handleGetAllEarningSuccess,
    [actions.getAllEarningError]: handleGetAllEarningError,

    [actions.getAllDeductionRequest]: handleGetAllDeductionRequest,
    [actions.getAllDeductionSuccess]: handleGetAllDeductionSuccess,
    [actions.getAllDeductionError]: handleGetAllDeductionError,

    [actions.calculateCtcRequest]: handleCalculateCtcRequest,
    [actions.calculateCtcSuccess]: handleCalculateCtcSuccess,
    [actions.calculateCtcError]: handleCalculateCtcError,

    [actions.addArrearsRequest]: handleAddArrearsRequest,
    [actions.addArrearsSuccess]: handleAddArrearsSuccess,
    [actions.addArrearsError]: handleAddArrearsError,

    [actions.getArrearsRequest]: handleGetArrearsRequest,
    [actions.getArrearsSuccess]: handleGetArrearsSuccess,
    [actions.getArrearsError]: handleGetArrearsError,

    [actions.addEmployeeSalaryRequest]: handleAddEmployeeSalaryRequest,
    [actions.addEmployeeSalarySuccess]: handleAddEmployeeSalarySuccess,
    [actions.addEmployeeSalaryError]: handleAddEmployeeSalaryError,

    [actions.addEmployeeSalaryRequest]: handleAddEmployeeSalaryRequest,
    [actions.addEmployeeSalarySuccess]: handleAddEmployeeSalarySuccess,
    [actions.addEmployeeSalaryError]: handleAddEmployeeSalaryError,

    [actions.getEmployeeSalaryRequest]: handleGetEmployeeSalaryRequest,
    [actions.getEmployeeSalarySuccess]: handleGetEmployeeSalarySuccess,
    [actions.getEmployeeSalaryError]: handleGetEmployeeSalaryError,

    [actions.updateEmployeeSalaryRequest]: handleUpdateEmployeeSalaryRequest,
    [actions.updateEmployeeSalarySuccess]: handleUpdateEmployeeSalarySuccess,
    [actions.updateEmployeeSalaryError]: handleUpdateEmployeeSalaryError,

    [actions.getAllEmployeeAssignStatusRequest]: handleGetAllEmployeeAssignStatusRequest,
    [actions.getAllEmployeeAssignStatusSuccess]: handleGetAllEmployeeAssignStatusSuccess,
    [actions.getAllEmployeeAssignStatusError]: handleGetAllEmployeeAssignStatusError,

    [actions.addPayRunRequest]: handleAddPayRunRequest,
    [actions.addPayRunSuccess]: handleAddPayRunSuccess,
    [actions.addPayRunError]: handleAddPayRunError,

    [actions.addPayScheduleRequest]: handleAddPayScheduleRequest,
    [actions.addPayScheduleSuccess]: handleAddPayScheduleSuccess,
    [actions.addPayScheduleError]: handleAddPayScheduleError,

    [actions.updatePayScheduleRequest]: handleUpdatePayScheduleRequest,
    [actions.updatePayScheduleSuccess]: handleUpdatePayScheduleSuccess,
    [actions.updatePayScheduleError]: handleUpdatePayScheduleError,

    [actions.upcomingPayrollsRequest]: handleUpcomingPayrollsRequest,
    [actions.upcomingPayrollsSuccess]: handleUpcomingPayrollsSuccess,
    [actions.upcomingPayrollsError]: handleUpcomingPayrollsError,

    [actions.payRollNotificationRequest]: handlePayRollNotificationRequest,
    [actions.payRollNotificationSuccess]: handlePayRollNotificationSuccess,
    [actions.payRollNotificationError]: handlePayRollNotificationError,

    [actions.getPayRunRequest]: handleGetPayRunRequest,
    [actions.getPayRunSuccess]: handleGetPayRunSuccess,
    [actions.getPayRunError]: handleGetPayRunError,

    [actions.getPayRunDashboardDataRequest]: handleGetPayRunDashboardDataRequest,
    [actions.getPayRunDashboardDataSuccess]: handleGetPayRunDashboardDataSuccess,
    [actions.getPayRunDashboardDataError]: handleGetPayRunDashboardDataError,

    [actions.getPayRunHistoryRequest]: handleGetPayRunHistoryRequest,
    [actions.getPayRunHistorySuccess]: handleGetPayRunHistorySuccess,
    [actions.getPayRunHistoryError]: handleGetPayRunHistoryError,

    [actions.approvePayrollRequest]: handleApprovePayrollRequest,
    [actions.approvePayrollSuccess]: handleApprovePayrollSuccess,
    [actions.approvePayrollError]: handleApprovePayrollError,

    [actions.addTaxSlabRequest]: handleAddTaxSlabRequest,
    [actions.addTaxSlabSuccess]: handleAddTaxSlabSuccess,
    [actions.addTaxSlabError]: handleAddTaxSlabError,

    [actions.updateTaxSlabRequest]: handleUpdateTaxSlabRequest,
    [actions.updateTaxSlabSuccess]: handleUpdateTaxSlabSuccess,
    [actions.updateTaxSlabError]: handleUpdateTaxSlabError,

    [actions.getTaxSlabRequest]: handleGetTaxSlabRequest,
    [actions.getTaxSlabSuccess]: handleGetTaxSlabSuccess,
    [actions.getTaxSlabError]: handleGetTaxSlabError,

    [actions.getAllTaxSlabRequest]: handleGetAllTaxSlabRequest,
    [actions.getAllTaxSlabSuccess]: handleGetAllTaxSlabSuccess,
    [actions.getAllTaxSlabError]: handleGetAllTaxSlabError,

    [actions.deleteTaxSlabRequest]: handleDeleteTaxSlabRequest,
    [actions.deleteTaxSlabSuccess]: handleDeleteTaxSlabSuccess,
    [actions.deleteTaxSlabError]: handleDeleteTaxSlabError,

    [actions.addEmployeeInvestmentRequest]: handleAddEmployeeInvestmentRequest,
    [actions.addEmployeeInvestmentSuccess]: handleAddEmployeeInvestmentSuccess,
    [actions.addEmployeeInvestmentError]: handleAddEmployeeInvestmentError,

    [actions.getEmployeeInvestmentRequest]: handleGetEmployeeInvestmentRequest,
    [actions.getEmployeeInvestmentSuccess]: handleGetEmployeeInvestmentSuccess,
    [actions.getEmployeeInvestmentError]: handleGetEmployeeInvestmentError,

    [actions.updateEmployeeInvestmentRequest]: handleUpdateEmployeeInvestmentRequest,
    [actions.updateEmployeeInvestmentSuccess]: handleUpdateEmployeeInvestmentSuccess,
    [actions.updateEmployeeInvestmentError]: handleUpdateEmployeeInvestmentError,

    [actions.deleteEmployeeInvestmentRequest]: handleDeleteEmployeeInvestmentRequest,
    [actions.deleteEmployeeInvestmentSuccess]: handleDeleteEmployeeInvestmentSuccess,
    [actions.deleteEmployeeInvestmentError]: handleDeleteEmployeeInvestmentError,

    [actions.addInvestmentCategoryRequest]: handleAddInvestmentCategoryRequest,
    [actions.addInvestmentCategorySuccess]: handleAddInvestmentCategorySuccess,
    [actions.addInvestmentCategoryError]: handleAddInvestmentCategoryError,

    [actions.updateInvestmentCategoryRequest]: handleUpdateInvestmentCategoryRequest,
    [actions.updateInvestmentCategorySuccess]: handleUpdateInvestmentCategorySuccess,
    [actions.updateInvestmentCategoryError]: handleUpdateInvestmentCategoryError,

    [actions.getInvestmentCategoryRequest]: handleGetInvestmentCategoryRequest,
    [actions.getInvestmentCategorySuccess]: handleGetInvestmentCategorySuccess,
    [actions.getInvestmentCategoryError]: handleGetInvestmentCategoryError,

    [actions.getAllInvestmentCategoryRequest]: handleGetAllInvestmentCategoryRequest,
    [actions.getAllInvestmentCategorySuccess]: handleGetAllInvestmentCategorySuccess,
    [actions.getAllInvestmentCategoryError]: handleGetAllInvestmentCategoryError,

    [actions.deleteInvestmentCategoryRequest]: handleDeleteInvestmentCategoryRequest,
    [actions.deleteInvestmentCategorySuccess]: handleDeleteInvestmentCategorySuccess,
    [actions.deleteInvestmentCategoryError]: handleDeleteInvestmentCategoryError,

    [actions.addInvestmentSubCategoryRequest]: handleAddInvestmentSubCategoryRequest,
    [actions.addInvestmentSubCategorySuccess]: handleAddInvestmentSubCategorySuccess,
    [actions.addInvestmentSubCategoryError]: handleAddInvestmentSubCategoryError,

    [actions.updateInvestmentSubCategoryRequest]: handleUpdateInvestmentSubCategoryRequest,
    [actions.updateInvestmentSubCategorySuccess]: handleUpdateInvestmentSubCategorySuccess,
    [actions.updateInvestmentSubCategoryError]: handleUpdateInvestmentSubCategoryError,

    [actions.getInvestmentSubCategoryRequest]: handleGetInvestmentSubCategoryRequest,
    [actions.getInvestmentSubCategorySuccess]: handleGetInvestmentSubCategorySuccess,
    [actions.getInvestmentSubCategoryError]: handleGetInvestmentSubCategoryError,

    [actions.getAllInvestmentSubCategoryRequest]: handleGetAllInvestmentSubCategoryRequest,
    [actions.getAllInvestmentSubCategorySuccess]: handleGetAllInvestmentSubCategorySuccess,
    [actions.getAllInvestmentSubCategoryError]: handleGetAllInvestmentSubCategoryError,

    [actions.deleteInvestmentSubCategoryRequest]: handleDeleteInvestmentSubCategoryRequest,
    [actions.deleteInvestmentSubCategorySuccess]: handleDeleteInvestmentSubCategorySuccess,
    [actions.deleteInvestmentSubCategoryError]: handleDeleteInvestmentSubCategoryError,

    [actions.getAllInvestmentCategoryDetailsRequest]: handleGetAllInvestmentCategoryDetailsRequest,
    [actions.getAllInvestmentCategoryDetailsSuccess]: handleGetAllInvestmentCategoryDetailsSuccess,
    [actions.getAllInvestmentCategoryDetailsError]: handleGetAllInvestmentCategoryDetailsError,

    [actions.addLoansRequest]: handleAddLoansRequest,
    [actions.addLoansSuccess]: handleAddLoansSuccess,
    [actions.addLoansError]: handleAddLoansError,

    [actions.updateLoansRequest]: handleUpdateLoansRequest,
    [actions.updateLoansSuccess]: handleUpdateLoansSuccess,
    [actions.updateLoansError]: handleUpdateLoansError,

    [actions.getLoansRequest]: handleGetLoansRequest,
    [actions.getLoansSuccess]: handleGetLoansSuccess,
    [actions.getLoansError]: handleGetLoansError,

    [actions.applyAdvanceRequest]: handleApplyAdvanceRequest,
    [actions.applyAdvanceSuccess]: handleApplyAdvanceSuccess,
    [actions.applyAdvanceError]: handleApplyAdvanceError,

    [actions.getAdvanceApprovalRequest]: handleGetAdvanceApprovalRequest,
    [actions.getAdvanceApprovalSuccess]: handleGetAdvanceApprovalSuccess,
    [actions.getAdvanceApprovalError]: handleGetAdvanceApprovalError,

    [actions.getAdvanceRequestRequest]: handleGetAdvanceRequestRequest,
    [actions.getAdvanceRequestSuccess]: handleGetAdvanceRequestSuccess,
    [actions.getAdvanceRequestError]: handleGetAdvanceRequestError,

    [actions.approvalRejectAdvanceRequest]: handleApprovalRejectAdvanceRequest,
    [actions.approvalRejectAdvanceSuccess]: handleApprovalRejectAdvanceSuccess,
    [actions.approvalRejectAdvanceError]: handleApprovalRejectAdvanceError,

    [actions.checkRuleFormulaRequest]: handleCheckRuleFormulaRequest,
    [actions.checkRuleFormulaSuccess]: handleCheckRuleFormulaSuccess,
    [actions.checkRuleFormulaError]: handleCheckRuleFormulaError,

    [actions.employeeInvestmentProofRequest]: handleEmployeeInvestmentProofRequest,
    [actions.employeeInvestmentProofSuccess]: handleEmployeeInvestmentProofSuccess,
    [actions.employeeInvestmentProofError]: handleEmployeeInvestmentProofError,

    [actions.getEmployeeInvestmentProofRequest]: handleGetEmployeeInvestmentProofRequest,
    [actions.getEmployeeInvestmentProofSuccess]: handleGetEmployeeInvestmentProofSuccess,
    [actions.getEmployeeInvestmentProofError]: handleGetEmployeeInvestmentProofError,

    [actions.updateEmployeeInvestmentProofRequest]: handleUpdateEmployeeInvestmentProofRequest,
    [actions.updateEmployeeInvestmentProofSuccess]: handleUpdateEmployeeInvestmentProofSuccess,
    [actions.updateEmployeeInvestmentProofError]: handleUpdateEmployeeInvestmentProofError,

    [actions.deleteEmployeeInvestmentProofRequest]: handleDeleteEmployeeInvestmentProofRequest,
    [actions.deleteEmployeeInvestmentProofSuccess]: handleDeleteEmployeeInvestmentProofSuccess,
    [actions.deleteEmployeeInvestmentProofError]: handleDeleteEmployeeInvestmentProofError,

    [actions.commentInEmployeeInvestmentProofRequest]: handleCommentInEmployeeInvestmentProofRequest,
    [actions.commentInEmployeeInvestmentProofSuccess]: handleCommentInEmployeeInvestmentProofSuccess,
    [actions.commentInEmployeeInvestmentProofError]: handleCommentInEmployeeInvestmentProofError,

    [actions.getAllEmployeeSalaryRequest]: handleGetAllEmployeeSalaryRequest,
    [actions.getAllEmployeeSalarySuccess]: handleGetAllEmployeeSalarySuccess,
    [actions.getAllEmployeeSalaryError]: handleGetAllEmployeeSalaryError,

    [actions.getEmployeeMonthlySalaryRequest]: handleGetEmployeeMonthlySalaryRequest,
    [actions.getEmployeeMonthlySalarySuccess]: handleGetEmployeeMonthlySalarySuccess,
    [actions.getEmployeeMonthlySalaryError]: handleGetEmployeeMonthlySalaryError,

    [actions.generateSalarySlipRequest]: handleGenerateSalarySlipRequest,
    [actions.generateSalarySlipSuccess]: handleGenerateSalarySlipSuccess,
    [actions.generateSalarySlipError]: handleGenerateSalarySlipError,

    [actions.sendOfferLetterRequest]: handleSendOfferLetterRequest,
    [actions.sendOfferLetterSuccess]: handleSendOfferLetterSuccess,
    [actions.sendOfferLetterError]: handleSendOfferLetterError,

    [actions.getCandidateSalaryRequest]: handleGetCandidateSalaryRequest,
    [actions.getCandidateSalarySuccess]: handleGetCandidateSalarySuccess,
    [actions.getCandidateSalaryError]: handleGetCandidateSalaryError,

    [actions.updateEmployeeMonthlySalaryRequest]: handleUpdateEmployeeMonthlySalaryRequest,
    [actions.updateEmployeeMonthlySalarySuccess]: handleUpdateEmployeeMonthlySalarySuccess,
    [actions.updateEmployeeMonthlySalaryError]: handleUpdateEmployeeMonthlySalaryError,

    [actions.deleteEarningTypeRequest]: handleDeleteEarningTypeRequest,
    [actions.deleteEarningTypeSuccess]: handleDeleteEarningTypeSuccess,
    [actions.deleteEarningTypeError]: handleDeleteEarningTypeError,

    [actions.deleteDeductionTypeRequest]: handleDeleteDeductionTypeRequest,
    [actions.deleteDeductionTypeSuccess]: handleDeleteDeductionTypeSuccess,
    [actions.deleteDeductionTypeError]: handleDeleteDeductionTypeError,

    [actions.deleteEarningRequest]: handleDeleteEarningRequest,
    [actions.deleteEarningSuccess]: handleDeleteEarningSuccess,
    [actions.deleteEarningError]: handleDeleteEarningError,

    [actions.deleteDeductionRequest]: handleDeleteDeductionRequest,
    [actions.deleteDeductionSuccess]: handleDeleteDeductionSuccess,
    [actions.deleteDeductionError]: handleDeleteDeductionError,

    [actions.deleteSalaryTemplateRequest]: handleDeleteSalaryTemplateRequest,
    [actions.deleteSalaryTemplateSuccess]: handleDeleteSalaryTemplateSuccess,
    [actions.deleteSalaryTemplateError]: handleDeleteSalaryTemplateError,

    [actions.getEmployeeMonthlyPaySlipRequest]: handleGetEmployeeMonthlyPaySlipRequest,
    [actions.getEmployeeMonthlyPaySlipSuccess]: handleGetEmployeeMonthlyPaySlipSuccess,
    [actions.getEmployeeMonthlyPaySlipError]: handleGetEmployeeMonthlyPaySlipError,

    [actions.selectedEmployeeData]: handleSelectedEmployeeData,

    [actions.actionTypeRequest]: handleActionType,
    [actions.handleClearPayrollStore]: clearPayrollStore,
  },
  initialState,
);